import { useState, useMemo, useRef, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import { sendNotificationEmail, commentEmailHTML, likeEmailHTML, followEmailHTML, reportEmailHTML } from "./utils/sendEmail";
import { createClient } from "@supabase/supabase-js";
/* eslint-disable no-unused-vars */

// ── Supabase client ────────────────────────────────────────────────────────────
// Replace these two values with your own from supabase.com → Project Settings → API
const SUPABASE_URL = "https://jgaxzpsnbgnmzfrybhdy.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpnYXh6cHNuYmdubXpmcnliaGR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MjExOTYsImV4cCI6MjA5NDA5NzE5Nn0.1TOF4-levdAG6M2-zN-vDk4t0QbiLYnWqvKHMPNR1IY";
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
const BG="#F5EDD8",CARD="#FFFCF4",BORDER="#E8DBBF",BORDER2="#D9CDAB";
const FONTS=`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Lora:ital,wght@0,400;0,500;1,400&family=Inter:wght@300;400;500;600&display=swap');`;
const MOBILE_CSS = `
  @media (max-width: 600px) {
    .nav-label { display: none !important; }
    .nav-btn { padding: 6px 8px !important; }
    .action-bar { flex-wrap: wrap !important; gap: 6px !important; }
    .action-btn { padding: 6px 10px !important; font-size: 11px !important; }
  }
`;
const POSTS=[
  {id:1,title:"I Died for Seven Minutes and Met the Light",excerpt:"The surgeon's voice was distant thunder as my spirit lifted from the table. What I encountered changed every belief I'd ever held about life, death, and the mercy of God.",content:"The heart monitor flatlined at 11:47 PM on a Tuesday.\n\nThere was no darkness. There was *light* — not harsh fluorescent but something warm and infinite, like the sun distilled into pure love.\n\nAnd then I heard my name. Not spoken — *known*.\n\nJesus was there. His presence was unmistakable — the same faithful friend who had kept every promise.\n\nHe said, simply: *\"Not yet.\"*\n\nI woke to my wife's crying. I've never been the same — not because of fear, but because of joy.",category:"NDE",tags:["near-death","heaven","light"],author:{name:"Thomas Ellery",initials:"TE",color:"#b45309"},date:"April 2, 2025",readTime:6,likes:847,comments:134,featured:true},
  {id:2,title:"The Night Jesus Walked Into My Prison Cell",excerpt:"I was serving fifteen years when the most unlikely visitor appeared at 3 AM. No door opened. No key turned. Yet everything locked inside me was set free.",content:"Fifteen years is a long time to sit with yourself.\n\nThe third night in my cell, I could not sleep. And then the room changed.\n\nI can only describe it as warmth that had no source. The gray went golden. Standing at the foot of my bunk was a figure — luminous is the only word.\n\nHe didn't condemn me. He said: *\"I know where you are. I've always known. And I've been waiting for you to stop running.\"*\n\nI wept for four hours. I am never alone in any room anymore.",category:"Jesus",tags:["redemption","prison","encounter"],author:{name:"Marcus Webb",initials:"MW",color:"#0f766e"},date:"March 18, 2025",readTime:7,likes:1204,comments:267,featured:true},
  {id:3,title:"A Stranger's Prayer Healed My Daughter",excerpt:"The doctors gave her six weeks. A woman I'd never met laid hands on my daughter and prayed with a certainty I will spend my life trying to equal.",content:"Her name is Lily and she is nine years old and alive because of a miracle.\n\nA woman sat beside me in the chapel and said: \"May I pray with you?\" She prayed with authority I had never encountered. She named Lily by name, though I had told her nothing.\n\nThree weeks later, the tumor had reduced by sixty percent. Eight weeks after — gone.\n\nThe oncologist said: \"I don't have a medical explanation for this.\"\n\nI do.",category:"Healing",tags:["miracle","children","prayer"],author:{name:"Rebecca Thorne",initials:"RT",color:"#7c3aed"},date:"February 28, 2025",readTime:5,likes:2341,comments:418,featured:false},
  {id:4,title:"When Doubt Led Me Back to the Altar",excerpt:"I spent three years as a convinced atheist with a seminary degree. What brought me home wasn't argument.",content:"I had the language for faith long before I had faith itself.\n\nI drove to the country church where my grandfather was baptized. It was midnight. I sat in a pew and said aloud: \"I don't believe any of this.\"\n\nThe presence came before I finished the sentence. Not a vision, not a voice — just *presence*. Heavy and warm and entirely unmistakable.\n\nI came back to the pulpit slower and humbler and, for the first time, *sure*.",category:"Church",tags:["doubt","faith","return"],author:{name:"David Cairns",initials:"DC",color:"#1d4ed8"},date:"February 10, 2025",readTime:8,likes:1876,comments:334,featured:false},
  {id:5,title:"The Voice That Stopped My Car",excerpt:"I heard my name spoken so clearly I checked the back seat. The next mile confirmed what the voice already knew: the bridge ahead had collapsed.",content:"I am a practical woman. A nurse. I believe in what can be measured.\n\nDecember 2019. Driving home exhausted. Then my name — clear and distinct. Then one word: *Stop.*\n\nEight minutes later an emergency alert lit my phone. The bridge I would have reached had collapsed. Two cars had already gone through.\n\n*\"Do not fear.\"* I understand now that the One who says it has earned the right.",category:"Protection",tags:["guardian","voice","miracle"],author:{name:"Janet Moore",initials:"JM",color:"#be185d"},date:"January 22, 2025",readTime:5,likes:987,comments:201,featured:false},
  {id:6,title:"God Found Me in the Valley of Addiction",excerpt:"Fifteen years of heroin took everything. What restored it all was not willpower — it was a power I had long stopped believing in.",content:"Rock bottom is not a floor. It is a turning point.\n\nI was living in a car in a church parking lot. The pastor found me and asked if I was hungry. After years of people telling me to leave — one man asked if I was hungry.\n\nHe said: \"There's a group Tuesday nights. You don't have to believe anything. You just have to show up.\"\n\nI've been clean eight years. My daughters call me Dad again.",category:"Healing",tags:["addiction","recovery","redemption"],author:{name:"Greg Okafor",initials:"GO",color:"#0f766e"},date:"January 8, 2025",readTime:9,likes:3102,comments:587,featured:false},
  {id:7,title:"The Night I Gave Everything to God",excerpt:"I was a successful attorney, a functional atheist, and deeply alone. A hotel room in Dallas changed everything.",content:"I had built a life that looked perfect from the outside.\n\nI was in a hotel room in Dallas. It was 11 PM. I had a glass of scotch and a view of the city and an ache I had no name for.\n\nI wasn't looking for God. I was just sitting by the window, and then I knew I was not alone in that room.\n\nI understood that I had been *known* since before I was born, and I had spent thirty-four years running from a love I was too proud to need.\n\nI wept for the first time since I was eight years old.",category:"Salvation",tags:["conversion","atheist","salvation"],author:{name:"Paul Whitfield",initials:"PW",color:"#1d4ed8"},date:"March 5, 2025",readTime:7,likes:2876,comments:412,featured:false},
  {id:8,title:"I Prayed for $80,000 and Got Something Better",excerpt:"My business was in debt with three weeks left. I prayed the most desperate prayer of my life — and God answered differently.",content:"At 2 AM in my office I asked God to send me $80,000.\n\nThree things happened in the next two weeks. None were what I asked for.\n\nA competitor offered an acquisition worth exactly $80,000 more than the debt. A lost client returned. A mentor offered six months of free consulting.\n\nI asked God for a rescue. He sent a renovation instead.",category:"Prayer",tags:["answered-prayer","business","faith"],author:{name:"Denise Ruark",initials:"DR",color:"#b45309"},date:"February 14, 2025",readTime:6,likes:1654,comments:298,featured:false},
  {id:9,title:"The Dream That Saved My Brother's Life",excerpt:"I woke at 3 AM from a dream so vivid I could feel the air. On the fourth call, my brother picked up from a hospital parking lot.",content:"I have never put much stock in dreams. I was a science teacher for twenty years.\n\nI woke at 3:17 AM from a dream about my brother sitting alone in a dark car. Then the feeling came: *go*.\n\nI called. No answer. Again. Again. On the fourth call he picked up from a hospital parking lot, not going in.\n\nHe told me he had asked God for one sign that anyone would notice if he was gone. His phone rang. He went inside. He is alive.",category:"Dreams",tags:["dream","vision","family"],author:{name:"Carol Simms",initials:"CS",color:"#7c3aed"},date:"January 30, 2025",readTime:7,likes:3891,comments:724,featured:false},
  {id:10,title:"God Provided the Exact Amount — Down to the Dollar",excerpt:"We needed $1,847 by Friday. I had $23. By Thursday night, we had exactly $1,847.",content:"We needed $1,847. On Tuesday I had $23. My husband had been out of work six weeks.\n\nWe prayed together for the first time in our marriage. I told God the exact number.\n\nWednesday: my aunt sent $400. That afternoon: a freelance project paid $900. Thursday morning: our church sent a check for $400. That afternoon: my husband's sister sent $147.\n\n$400 + $900 + $400 + $147 = $1,847. I have the bank statements.",category:"Provision",tags:["provision","finances","prayer"],author:{name:"Alicia Monroe",initials:"AM",color:"#0f766e"},date:"January 15, 2025",readTime:5,likes:4210,comments:893,featured:false},
  {id:11,title:"Twenty Years of Fear Left in an Hour",excerpt:"Since childhood I had woken at 3 AM certain something dark was in my room. Then one evening at a prayer meeting, it simply left.",content:"I was six the first time I woke certain something was there — something heavy and specific.\n\nBy adulthood it was as familiar as any feature of my life. Therapists called it sleep paralysis. The fear did not respond to explanations.\n\nAt a prayer meeting a woman sat beside me and said: *\"I feel like tonight is the night it leaves.\"*\n\nShe prayed for ten minutes. I felt a weight lift off my chest and leave the room. Suddenly. Like a door closing.\n\nI have not woken in fear since that night. Four years ago.",category:"Deliverance",tags:["deliverance","fear","freedom"],author:{name:"Nina Osei",initials:"NO",color:"#be185d"},date:"December 20, 2024",readTime:8,likes:2543,comments:481,featured:false},
];

const CATS=["All","NDE","Jesus","Church","Healing","Protection","Salvation","Prayer","Dreams","Provision","Deliverance","Marriage","Family","Grief","Forgiveness","Anxiety","Cancer","Miracles","Angels","Prophecy","Missions","Worship","Fasting","Youth","Children","Career","Education","Mental Health","Relationships","Loneliness","Restoration","Hope","Peace","Joy","Suffering","Trials","Persecution","Generosity","Ministry","Evangelism","Holy Spirit","Baptism","Community","Warfare","Second Chances","Identity","Addiction","Transformation","Loss","Pregnancy","Suicide Prevention"];

const CAT_STYLE={NDE:{bg:"#FEF3C7",text:"#92400E",border:"#FCD34D"},Jesus:{bg:"#DBEAFE",text:"#1E3A8A",border:"#93C5FD"},Church:{bg:"#EDE9FE",text:"#4C1D95",border:"#C4B5FD"},Healing:{bg:"#D1FAE5",text:"#064E3B",border:"#6EE7B7"},Protection:{bg:"#FCE7F3",text:"#9D174D",border:"#F9A8D4"},Salvation:{bg:"#FFF7ED",text:"#9A3412",border:"#FDBA74"},Prayer:{bg:"#F0F9FF",text:"#0C4A6E",border:"#7DD3FC"},Dreams:{bg:"#F5F3FF",text:"#3730A3",border:"#A5B4FC"},Provision:{bg:"#ECFDF5",text:"#065F46",border:"#34D399"},Deliverance:{bg:"#FFF1F2",text:"#881337",border:"#FDA4AF"},Marriage:{bg:"#FFF0F0",text:"#9F1239",border:"#FECACA"},Family:{bg:"#FFFBEB",text:"#78350F",border:"#FDE68A"},Grief:{bg:"#F1F5F9",text:"#334155",border:"#94A3B8"},Forgiveness:{bg:"#FAF5FF",text:"#6B21A8",border:"#D8B4FE"},Anxiety:{bg:"#ECFEFF",text:"#164E63",border:"#67E8F9"},Cancer:{bg:"#FFF5F0",text:"#7C2D12",border:"#FDBA74"},Miracles:{bg:"#FEFCE8",text:"#713F12",border:"#FDE047"},Angels:{bg:"#F0F9FF",text:"#0369A1",border:"#BAE6FD"},Prophecy:{bg:"#F5F0FF",text:"#5B21B6",border:"#C4B5FD"},Missions:{bg:"#F0FDF4",text:"#14532D",border:"#86EFAC"},Worship:{bg:"#FFF0F6",text:"#831843",border:"#F9A8D4"},Fasting:{bg:"#F8FAFC",text:"#475569",border:"#CBD5E1"},Youth:{bg:"#ECFDF5",text:"#065F46",border:"#6EE7B7"},Children:{bg:"#FFF7ED",text:"#C2410C",border:"#FED7AA"},Career:{bg:"#EFF6FF",text:"#1E40AF",border:"#BFDBFE"},Education:{bg:"#FEFCE8",text:"#854D0E",border:"#FEF08A"},"Mental Health":{bg:"#F0FDF9",text:"#134E4A",border:"#99F6E4"},Relationships:{bg:"#FDF2F8",text:"#831843",border:"#F0ABFC"},Loneliness:{bg:"#EEF2FF",text:"#3730A3",border:"#A5B4FC"},Restoration:{bg:"#F0FDF4",text:"#166534",border:"#86EFAC"},Hope:{bg:"#FFF7ED",text:"#9A3412",border:"#FB923C"},Peace:{bg:"#F0FDFA",text:"#134E4A",border:"#5EEAD4"},Joy:{bg:"#FEFCE8",text:"#713F12",border:"#FDE047"},Suffering:{bg:"#FDF4FF",text:"#701A75",border:"#E879F9"},Trials:{bg:"#FFF8F1",text:"#7C2D12",border:"#FDBA74"},Persecution:{bg:"#FFF1F2",text:"#9F1239",border:"#FCA5A5"},Generosity:{bg:"#ECFDF5",text:"#14532D",border:"#4ADE80"},Ministry:{bg:"#EFF6FF",text:"#1E3A8A",border:"#93C5FD"},Evangelism:{bg:"#FFF7ED",text:"#C2410C",border:"#FB923C"},"Holy Spirit":{bg:"#F0F9FF",text:"#0C4A6E",border:"#38BDF8"},Baptism:{bg:"#ECFEFF",text:"#155E75",border:"#67E8F9"},Community:{bg:"#FAFAF9",text:"#44403C",border:"#D6D3D1"},Warfare:{bg:"#FFF1F2",text:"#7F1D1D",border:"#FCA5A5"},"Second Chances":{bg:"#F0FDF4",text:"#14532D",border:"#86EFAC"},Identity:{bg:"#F5F3FF",text:"#4C1D95",border:"#C4B5FD"},Addiction:{bg:"#FDF4FF",text:"#6B21A8",border:"#D8B4FE"},Transformation:{bg:"#ECFDF5",text:"#065F46",border:"#34D399"},Loss:{bg:"#F8FAFC",text:"#334155",border:"#94A3B8"},Pregnancy:{bg:"#FFF0F6",text:"#9D174D",border:"#F9A8D4"},"Suicide Prevention":{bg:"#F0F9FF",text:"#0C4A6E",border:"#7DD3FC"}};

const LANGS=[
  {code:"en",flag:"\ud83c\uddfa\ud83c\uddf8",name:"English"},
  {code:"es",flag:"\ud83c\uddea\ud83c\uddf8",name:"Español"},
  {code:"fr",flag:"\ud83c\uddeb\ud83c\uddf7",name:"Français"},
  {code:"pt",flag:"\ud83c\udde7\ud83c\uddf7",name:"Português"},
  {code:"de",flag:"\ud83c\udde9\ud83c\uddea",name:"Deutsch"},
  {code:"zh",flag:"\ud83c\udde8\ud83c\uddf3",name:"中文"},
  {code:"ko",flag:"\ud83c\uddf0\ud83c\uddf7",name:"한국어"},
  {code:"hi",flag:"\ud83c\uddee\ud83c\uddf3",name:"हिंदी"},
  {code:"ar",flag:"\ud83c\uddf8\ud83c\udde6",name:"العربية"},
  {code:"sw",flag:"\ud83c\uddf0\ud83c\uddea",name:"Kiswahili"},
];

const TR={
  en:{hero:"Give Glory Through Your Story",tagline:"Your testimony belongs to someone who hasn't read it yet.",share:"Share Your Story",night:"Night",light:"Light",search:"Search testimonies...",featured:"Featured",back:"Back to stories",save:"Save",postResp:"Post Response",responses:"Responses",words:"words",minRead:"min read",noLimit:"No limit — write as much as God puts on your heart",cancel:"Cancel",draft:"Save draft",publish:"Publish",addCover:"Add cover photo",changeCover:"Change cover",insertImg:"Insert image",pasteHint:"Or paste images directly",remove:"Remove",noStories:"No stories found",trySearch:"Try a different search or category",results:"results",result:"result",stat1:"Stories Shared",stat2:"Christians Worldwide",stat3:"Growing Daily",jer:"For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you.",jerRef:"Jeremiah 29:11",rev:"They triumphed over him by the blood of the Lamb and by the word of their testimony.",revRef:"Revelation 12:11",commentHint:"Share how this testimony touched your heart...",titleHint:"Your story's title...",bodyHint:"Tell your testimony here. Write from the heart."},
  es:{hero:"Dale gloria a Dios con tu historia",tagline:"Tu testimonio le pertenece a alguien que no lo ha leido.",share:"Comparte tu historia",night:"Noche",light:"Dia",search:"Buscar testimonios...",featured:"Destacado",back:"Volver",save:"Guardar",postResp:"Publicar respuesta",responses:"Respuestas",words:"palabras",minRead:"min",noLimit:"Sin limite — escribe todo lo que Dios ponga en tu corazon",cancel:"Cancelar",draft:"Guardar borrador",publish:"Publicar",addCover:"Agregar portada",changeCover:"Cambiar portada",insertImg:"Insertar imagen",pasteHint:"O pega imagenes directamente",remove:"Eliminar",noStories:"No se encontraron historias",trySearch:"Intenta otra busqueda",results:"resultados",result:"resultado",stat1:"2,400+ Historias",stat2:"84 Paises",stat3:"Creciendo",jer:"Porque yo se los planes que tengo para ustedes, dice el Senor, planes de bienestar.",jerRef:"Jeremias 29:11",rev:"Ellos lo han vencido por la sangre del Cordero y por la palabra de su testimonio.",revRef:"Apocalipsis 12:11",commentHint:"Comparte como este testimonio toco tu corazon...",titleHint:"El titulo de tu historia...",bodyHint:"Cuentanos tu testimonio aqui. Usa *asteriscos* para enfasis."},
  fr:{hero:"Glorifiez Dieu par votre histoire",tagline:"Votre temoignage appartient a quelqu'un qui ne l'a pas encore lu.",share:"Partagez votre histoire",night:"Nuit",light:"Jour",search:"Rechercher des temoignages...",featured:"A la une",back:"Retour",save:"Sauvegarder",postResp:"Publier",responses:"Reponses",words:"mots",minRead:"min",noLimit:"Sans limite — ecrivez autant que Dieu le met sur votre coeur",cancel:"Annuler",draft:"Sauver brouillon",publish:"Publier",addCover:"Ajouter une couverture",changeCover:"Changer la couverture",insertImg:"Inserer une image",pasteHint:"Ou collez des images directement",remove:"Supprimer",noStories:"Aucune histoire trouvee",trySearch:"Essayez une autre recherche",results:"resultats",result:"resultat",stat1:"2 400+ Histoires",stat2:"84 Pays",stat3:"En croissance",jer:"Car je connais les projets que j'ai formes sur vous, dit l'Eternel, projets de paix.",jerRef:"Jeremie 29:11",rev:"Ils l'ont vaincu par le sang de l'Agneau et par la parole de leur temoignage.",revRef:"Apocalypse 12:11",commentHint:"Partagez comment ce temoignage a touche votre coeur...",titleHint:"Le titre de votre histoire...",bodyHint:"Racontez votre temoignage ici."},
  pt:{hero:"De gloria a Deus pela sua historia",tagline:"O seu testemunho pertence a alguem que ainda nao o leu.",share:"Compartilhe sua historia",night:"Noite",light:"Dia",search:"Pesquisar testemunhos...",featured:"Destaque",back:"Voltar",save:"Salvar",postResp:"Publicar resposta",responses:"Respostas",words:"palavras",minRead:"min",noLimit:"Sem limite — escreva o quanto Deus colocar em seu coracao",cancel:"Cancelar",draft:"Salvar rascunho",publish:"Publicar",addCover:"Adicionar capa",changeCover:"Mudar capa",insertImg:"Inserir imagem",pasteHint:"Ou cole imagens diretamente",remove:"Remover",noStories:"Nenhuma historia encontrada",trySearch:"Tente outra pesquisa",results:"resultados",result:"resultado",stat1:"2.400+ Historias",stat2:"84 Paises",stat3:"Crescendo",jer:"Porque eu sei os planos que tenho para voces, diz o Senhor, planos de prosperidade.",jerRef:"Jeremias 29:11",rev:"Eles o venceram pelo sangue do Cordeiro e pela palavra do testemunho deles.",revRef:"Apocalipse 12:11",commentHint:"Compartilhe como este testemunho tocou seu coracao...",titleHint:"O titulo da sua historia...",bodyHint:"Conte seu testemunho aqui."},
  de:{hero:"Gib Gott die Ehre durch deine Geschichte",tagline:"Dein Zeugnis gehoert jemandem, der es noch nicht gelesen hat.",share:"Teile deine Geschichte",night:"Nacht",light:"Tag",search:"Zeugnisse suchen...",featured:"Empfohlen",back:"Zurueck",save:"Speichern",postResp:"Antwort posten",responses:"Antworten",words:"Woerter",minRead:"Min.",noLimit:"Kein Limit — schreibe so viel Gott dir aufs Herz legt",cancel:"Abbrechen",draft:"Entwurf speichern",publish:"Veroeffentlichen",addCover:"Titelbild hinzufuegen",changeCover:"Titelbild aendern",insertImg:"Bild einfuegen",pasteHint:"Oder Bilder direkt einfuegen",remove:"Entfernen",noStories:"Keine Geschichten gefunden",trySearch:"Versuche eine andere Suche",results:"Ergebnisse",result:"Ergebnis",stat1:"2.400+ Geschichten",stat2:"84 Laender",stat3:"Waechst taeglich",jer:"Denn ich kenne die Gedanken, die ich ueber euch habe, spricht der Herr, Gedanken des Heils.",jerRef:"Jeremia 29:11",rev:"Sie haben ihn ueberwunden durch das Blut des Lammes und durch das Wort ihres Zeugnisses.",revRef:"Offenbarung 12:11",commentHint:"Teile, wie dieses Zeugnis dein Herz beruehrt hat...",titleHint:"Der Titel deiner Geschichte...",bodyHint:"Teile dein Zeugnis hier."},
  zh:{hero:"\u7528\u4f60\u7684\u6545\u4e8b\u8363\u8000\u795e",tagline:"\u4f60\u7684\u89c1\u8bc1\u5c5e\u4e8e\u4e00\u4e2a\u8fd8\u6ca1\u6709\u8bfb\u5230\u5b83\u7684\u4eba\u3002",share:"\u5206\u4eab\u4f60\u7684\u6545\u4e8b",night:"\u591c\u95f4",light:"\u65e5\u95f4",search:"\u641c\u7d22\u89c1\u8bc1...",featured:"\u7cbe\u9009",back:"\u8fd4\u56de",save:"\u4fdd\u5b58",postResp:"\u53d1\u8868\u56de\u5e94",responses:"\u56de\u5e94",words:"\u5b57",minRead:"\u5206\u949f\u9605\u8bfb",noLimit:"\u6ca1\u6709\u9650\u5236",cancel:"\u53d6\u6d88",draft:"\u4fdd\u5b58\u8349\u7a3f",publish:"\u53d1\u5e03",addCover:"\u6dfb\u52a0\u5c01\u9762",changeCover:"\u66f4\u6362\u5c01\u9762",insertImg:"\u63d2\u5165\u56fe\u7247",pasteHint:"\u6216\u76f4\u63a5\u7c98\u8d34\u56fe\u7247",remove:"\u5220\u9664",noStories:"\u672a\u627e\u5230\u6545\u4e8b",trySearch:"\u5c1d\u8bd5\u4e0d\u540c\u7684\u641c\u7d22\u6216\u5206\u7c7b",results:"\u6761\u7ed3\u679c",result:"\u6761\u7ed3\u679c",stat1:"2,400+ \u6545\u4e8b",stat2:"84 \u4e2a\u56fd\u5bb6",stat3:"\u6301\u7eed\u589e\u957f",jer:"\u8033\u548c\u534e\u8bf4\uff1a\u6211\u77e5\u9053\u6211\u5411\u4f60\u4eec\u6240\u6000\u7684\u610f\u5ff5\uff0c\u662f\u8d50\u5e73\u5b89\u7684\u610f\u5ff5\u3002",jerRef:"\u8033\u5229\u7c73\u4e66 29:11",rev:"\u4ed6\u4eec\u56e0\u7f94\u7f8a\u7684\u8840\uff0c\u5e76\u81ea\u5df1\u6240\u89c1\u8bc1\u7684\u9053\uff0c\u80dc\u8fc7\u4e86\u4ed6\u3002",revRef:"\u542f\u793a\u5f55 12:11",commentHint:"\u5206\u4eab\u8fd9\u4e2a\u89c1\u8bc1\u5982\u4f55\u611f\u52a8\u4e86\u4f60\u7684\u5fc3...",titleHint:"\u4f60\u7684\u6545\u4e8b\u6807\u9898...",bodyHint:"\u5728\u8fd9\u91cc\u5206\u4eab\u4f60\u7684\u89c1\u8bc1\u3002"},
  ko:{hero:"\ub2f9\uc2e0\uc758 \uc774\uc57c\uae30\ub85c \ud558\ub098\ub2d8\uaed8 \uc601\uad11\uc744",tagline:"\ub2f9\uc2e0\uc758 \uac04\uc99d\uc740 \uc544\uc9c1 \uc77d\uc9c0 \ubabb\ud55c \ub204\uad70\uac00\uc758 \uac83\uc785\ub2c8\ub2e4.",share:"\uc774\uc57c\uae30 \ub098\ub204\uae30",night:"\uc57c\uac04",light:"\uc8fc\uac04",search:"\uac04\uc99d \uac80\uc0c9...",featured:"\ucd94\uccad",back:"\ubaa9\ub85d\uc73c\ub85c",save:"\uc800\uc7a5",postResp:"\ub313\uae00 \ub2ec\uae30",responses:"\uc751\ub2f5",words:"\ub2e8\uc5b4",minRead:"\ubd84 \uc77d\uae30",noLimit:"\uc81c\ud55c \uc5c6\uc74c",cancel:"\ucde8\uc18c",draft:"\uc784\uc2dc \uc800\uc7a5",publish:"\uac8c\uc2dc",addCover:"\ud45c\uc9c0 \ucd94\uac00",changeCover:"\ud45c\uc9c0 \ubcc0\uacbd",insertImg:"\uc774\ubbf8\uc9c0 \uc0bd\uc785",pasteHint:"\ub610\ub294 \uc774\ubbf8\uc9c0\ub97c \uc9c1\uc811 \ubd99\uc5ec\ub123\uae30",remove:"\uc0ad\uc81c",noStories:"\uc774\uc57c\uae30\ub97c \ucc3e\uc744 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4",trySearch:"\ub2e4\ub978 \uac80\uc0c9\uc5b4\ub098 \uce74\ud14c\uace0\ub9ac\ub97c \uc2dc\ub3c4\ud574\ubcf4\uc138\uc694",results:"\uacb0\uacfc",result:"\uacb0\uacfc",stat1:"2,400+ \uc774\uc57c\uae30",stat2:"84\uac1c\uad6d",stat3:"\ub9e4\uc77c \uc131\uc7a5 \uc911",jer:"\uc5ec\ud638\uc640\uc758 \ub9d0\uc500\uc774\ub2c8\ub77c \ub108\ud76c\ub97c \ud5a5\ud55c \ub098\uc758 \uc0dd\uac01\uc744 \ub0b4\uac00 \uc544\ub098\ub2c8 \ud3c9\uc548\uc774\uc694.",jerRef:"\uc608\ub808\ubbf8\uc57c 29:11",rev:"\uadf8\ub4e4\uc774 \uc5b4\ub9b0 \uc591\uc758 \ud53c\uc640 \uc790\uae30\ub4e4\uc758 \uc99d\uac70\ud558\ub294 \ub9d0\uc528\uc73c\ub85c\uc368 \uc774\uaca8\uc2b5\ub2c8\ub2e4.",revRef:"\uc694\ud55c\uacc4\uc2dc\ub85d 12:11",commentHint:"\uc774 \uac04\uc99d\uc774 \ub2f9\uc2e0\uc758 \ub9c8\uc74c\uc744 \uc5b4\ub5bb\uac8c \ub9cc\uc98c\ub294\uc9c0 \ub098\ub220\uc8fc\uc138\uc694...",titleHint:"\uc774\uc57c\uae30 \uc81c\ubaa9...",bodyHint:"\uc5ec\uae30\uc5d0 \uac04\uc99d\uc744 \uc801\uc5b4\uc8fc\uc138\uc694."},
  hi:{hero:"\u0905\u092a\u0928\u0940 \u0915\u0939\u093e\u0928\u0940 \u0938\u0947 \u092a\u0930\u092e\u0947\u0936\u094d\u0935\u0930 \u0915\u0940 \u092e\u0939\u093f\u092e\u093e \u0915\u0930\u0947\u0902",tagline:"\u0906\u092a\u0915\u0940 \u0917\u0935\u093e\u0939\u0940 \u0915\u093f\u0938\u0940 \u0910\u0938\u0947 \u0935\u094d\u092f\u0915\u094d\u0924\u093f \u0915\u0940 \u0939\u0948 \u091c\u093f\u0938\u0928\u0947 \u0907\u0938\u0947 \u0905\u092d\u0940 \u0928\u0939\u0940\u0902 \u092a\u0922\u093c\u093e \u0939\u0948\u0964",share:"\u0905\u092a\u0928\u0940 \u0915\u0939\u093e\u0928\u0940 \u0938\u093e\u091d\u093e \u0915\u0930\u0947\u0902",night:"\u0930\u093e\u0924",light:"\u0926\u093f\u0928",search:"\u0917\u0935\u093e\u0939\u093f\u092f\u093e\u0901 \u0916\u094b\u091c\u0947\u0902...",featured:"\u0935\u093f\u0936\u0947\u0937",back:"\u0935\u093e\u092a\u0938 \u091c\u093e\u090f\u0902",save:"\u0938\u0939\u0947\u091c\u0947\u0902",postResp:"\u091c\u0935\u093e\u092c \u092a\u094b\u0938\u094d\u091f \u0915\u0930\u0947\u0902",responses:"\u091c\u0935\u093e\u092c",words:"\u0936\u092c\u094d\u0926",minRead:"\u092e\u093f\u0928\u091f",noLimit:"\u0915\u094b\u0908 \u0938\u0940\u092e\u093e \u0928\u0939\u0940\u0902",cancel:"\u0930\u0926\u094d\u0926 \u0915\u0930\u0947\u0902",draft:"\u0921\u094d\u0930\u093e\u092b\u094d\u091f \u0938\u0939\u0947\u091c\u0947\u0902",publish:"\u092a\u094d\u0930\u0915\u093e\u0936\u093f\u0924 \u0915\u0930\u0947\u0902",addCover:"\u0915\u0935\u0930 \u092b\u093c\u094b\u091f\u094b \u091c\u094b\u0921\u093c\u0947\u0902",changeCover:"\u0915\u0935\u0930 \u092c\u0926\u0932\u0947\u0902",insertImg:"\u091b\u0935\u093f \u0921\u093e\u0932\u0947\u0902",pasteHint:"\u092f\u093e \u0938\u0940\u0927\u0947 \u091a\u093f\u092a\u0915\u093e\u090f\u0902",remove:"\u0939\u091f\u093e\u090f\u0902",noStories:"\u0915\u094b\u0908 \u0915\u0939\u093e\u0928\u0940 \u0928\u0939\u0940\u0902 \u092e\u093f\u0932\u0940",trySearch:"\u0905\u0928\u094d\u092f \u0916\u094b\u091c \u0906\u091c\u093c\u092e\u093e\u090f\u0902",results:"\u092a\u0930\u093f\u0923\u093e\u092e",result:"\u092a\u0930\u093f\u0923\u093e\u092e",stat1:"2,400+ \u0915\u0939\u093e\u0928\u093f\u092f\u093e\u0901",stat2:"84 \u0926\u0947\u0936",stat3:"\u0930\u094b\u091c\u093c \u092c\u0922\u093c \u0930\u0939\u093e \u0939\u0948",jer:"\u092f\u0939\u094b\u0935\u093e \u0915\u0940 \u0935\u093e\u0923\u0940 \u0939\u0948: \u091c\u094b \u0935\u093f\u091a\u093e\u0930 \u092e\u0948\u0902 \u0924\u0941\u092e\u094d\u0939\u093e\u0930\u0947 \u0935\u093f\u0937\u092f \u0938\u094b\u091a\u0924\u093e \u0939\u0942\u0901 \u0935\u0947 \u0915\u0932\u094d\u092f\u093e\u0923 \u0915\u0947 \u0935\u093f\u091a\u093e\u0930 \u0939\u0948\u0902\u0964",jerRef:"\u092f\u093f\u0930\u094d\u092e\u092f\u093e\u0939 29:11",rev:"\u0909\u0928\u094d\u0939\u094b\u0902\u0928\u0947 \u092e\u0947\u092e\u094d\u0928\u0947 \u0915\u0947 \u0932\u0939\u0942 \u0914\u0930 \u0905\u092a\u0928\u0940 \u0917\u0935\u093e\u0939\u0940 \u0915\u0947 \u0935\u091a\u0928 \u0915\u0947 \u0915\u093e\u0930\u0923 \u091c\u092f \u092a\u093e\u0908\u0964",revRef:"\u092a\u094d\u0930\u0915\u093e\u0936\u093f\u0924\u0935\u093e\u0915\u094d\u092f 12:11",commentHint:"\u0938\u093e\u091d\u093e \u0915\u0930\u0947\u0902...",titleHint:"\u0906\u092a\u0915\u0940 \u0915\u0939\u093e\u0928\u0940 \u0915\u093e \u0936\u0940\u0930\u094d\u0937\u0915...",bodyHint:"\u092f\u0939\u093e\u0901 \u0905\u092a\u0928\u0940 \u0917\u0935\u093e\u0939\u0940 \u0932\u093f\u0916\u0947\u0902\u0964"},
  ar:{hero:"\u0627\u0645\u062c\u062f \u0627\u0644\u0644\u0647 \u0645\u0646 \u062e\u0644\u0627\u0644 \u0642\u0635\u062a\u0643",tagline:"\u0634\u0647\u0627\u062f\u062a\u0643 \u062a\u0646\u062a\u0645\u064a \u0644\u0634\u062e\u0635 \u0644\u0645 \u064a\u0642\u0631\u0623\u0647\u0627 \u0628\u0639\u062f.",share:"\u0634\u0627\u0631\u0643 \u0642\u0635\u062a\u0643",night:"\u0627\u0644\u0644\u064a\u0644",light:"\u0627\u0644\u0646\u0647\u0627\u0631",search:"\u0627\u0628\u062d\u062b \u0641\u064a \u0627\u0644\u0634\u0647\u0627\u062f\u0627\u062a...",featured:"\u0645\u0645\u064a\u0632",back:"\u0627\u0644\u0639\u0648\u062f\u0629",save:"\u062d\u0641\u0638",postResp:"\u0646\u0634\u0631 \u0627\u0644\u0631\u062f",responses:"\u0631\u062f\u0648\u062f",words:"\u0643\u0644\u0645\u0629",minRead:"\u062f \u0642\u0631\u0627\u0621\u0629",noLimit:"\u0628\u0644\u0627 \u062d\u062f\u0648\u062f",cancel:"\u0625\u0644\u063a\u0627\u0621",draft:"\u062d\u0641\u0638 \u0645\u0633\u0648\u062f\u0629",publish:"\u0646\u0634\u0631",addCover:"\u0625\u0636\u0627\u0641\u0629 \u063a\u0644\u0627\u0641",changeCover:"\u062a\u063a\u064a\u064a\u0631 \u0627\u0644\u063a\u0644\u0627\u0641",insertImg:"\u0625\u062f\u0631\u0627\u062c \u0635\u0648\u0631\u0629",pasteHint:"\u0623\u0648 \u0627\u0644\u0635\u0642 \u0635\u0648\u0631\u0629",remove:"\u0625\u0632\u0627\u0644\u0629",noStories:"\u0644\u0627 \u062a\u0648\u062c\u062f \u0642\u0635\u0635",trySearch:"\u062c\u0631\u0628 \u0628\u062d\u062b\u0627 \u0622\u062e\u0631",results:"\u0646\u062a\u0627\u0626\u062c",result:"\u0646\u062a\u064a\u062c\u0629",stat1:"+2,400 \u0642\u0635\u0629",stat2:"84 \u062f\u0648\u0644\u0629",stat3:"\u064a\u0646\u0645\u0648 \u064a\u0648\u0645\u064a\u0627",jer:"\u064a\u0642\u0648\u0644 \u0627\u0644\u0631\u0628: \u0625\u0646\u064a \u0623\u0639\u0631\u0641 \u0627\u0644\u0623\u0641\u0643\u0627\u0631 \u0627\u0644\u062a\u064a \u0623\u0641\u0643\u0631 \u0628\u0647\u0627 \u0646\u062d\u0648\u0643\u0645\u060c \u0623\u0641\u0643\u0627\u0631 \u0633\u0644\u0627\u0645.",jerRef:"\u0625\u0631\u0645\u064a\u0627 29:11",rev:"\u0648\u0647\u0645 \u0642\u062f \u063a\u0644\u0628\u0648\u0647 \u0628\u062f\u0645 \u0627\u0644\u062e\u0631\u0648\u0641 \u0648\u0628\u0643\u0644\u0645\u0629 \u0634\u0647\u0627\u062f\u062a\u0647\u0645.",revRef:"\u0631\u0624\u064a\u0627 12:11",commentHint:"\u0634\u0627\u0631\u0643 \u0643\u064a\u0641 \u0644\u0645\u0633\u062a\u0643 \u0647\u0630\u0647 \u0627\u0644\u0634\u0647\u0627\u062f\u0629...",titleHint:"\u0639\u0646\u0648\u0627\u0646 \u0642\u0635\u062a\u0643...",bodyHint:"\u0627\u0643\u062a\u0628 \u0634\u0647\u0627\u062f\u062a\u0643 \u0647\u0646\u0627."},
  sw:{hero:"Mpe Mungu utukufu kupitia hadithi yako",tagline:"Ushuhuda wako ni wa mtu ambaye bado haujasoma.",share:"Shiriki hadithi yako",night:"Usiku",light:"Mchana",search:"Tafuta ushuhuda...",featured:"Iliyoangaziwa",back:"Rudi",save:"Hifadhi",postResp:"Chapisha jibu",responses:"Majibu",words:"maneno",minRead:"dk",noLimit:"Bila kikomo",cancel:"Ghairi",draft:"Hifadhi rasimu",publish:"Chapisha",addCover:"Ongeza jalada",changeCover:"Badilisha jalada",insertImg:"Ingiza picha",pasteHint:"Au bandika picha",remove:"Ondoa",noStories:"Hakuna hadithi",trySearch:"Jaribu utafutaji mwingine",results:"matokeo",result:"matokeo",stat1:"Hadithi 2,400+",stat2:"Nchi 84",stat3:"Inakua",jer:"Kwa maana najua mawazo ninayoyawaza juu yenu, asema Bwana, mawazo ya amani.",jerRef:"Yeremia 29:11",rev:"Nao walimshinda kwa damu ya Mwana-Kondoo, na kwa neno la ushuhuda wao.",revRef:"Ufunuo 12:11",commentHint:"Shiriki jinsi ushuhuda huu ulivyogusa moyo wako...",titleHint:"Kichwa cha hadithi yako...",bodyHint:"Andika ushuhuda wako hapa."},
};

const fmt2=n=>n>=1000?(n/1000).toFixed(1)+"k":String(n);


function Logo({size=44}){
  const h=size*1.18,frame="#6B3A28";
  const cols=[9,30,51,71],rows=[9,21,33,45,57,69,81,94];
  const pal=["#C4AEDC","#EED888","#EDB0C4","#9EC4E8","#A0D4B8","#B8D8F4","#E4B4C8","#B0D4A8"];
  return(
    <svg width={size} height={h} viewBox="0 0 80 95" style={{display:"block",filter:"drop-shadow(0 2px 8px rgba(0,0,0,0.18))"}}>
      <defs>
        <clipPath id="arch"><path d="M9,94 L9,52 C9,24 9,18 40,8 C71,18 71,24 71,52 L71,94 Z"/></clipPath>
        <radialGradient id="frm" cx="30%" cy="20%" r="80%"><stop offset="0%" stopColor="#8A5038"/><stop offset="100%" stopColor="#48220E"/></radialGradient>
      </defs>
      <path d="M3,95 L3,50 C3,22 3,14 40,2 C77,14 77,22 77,50 L77,95 Z" fill="url(#frm)"/>
      <g clipPath="url(#arch)">
        {rows.slice(0,-1).map((y,ri)=>cols.slice(0,-1).map((x,ci)=>(
          <rect key={`${ri}-${ci}`} x={x} y={y} width={cols[ci+1]-x} height={rows[ri+1]-y} fill={pal[(ri*3+ci)%pal.length]}/>
        )))}
      </g>
      <rect x="9" y="44" width="62" height="4" fill="url(#frm)" clipPath="url(#arch)"/>
      <rect x="38" y="8" width="4" height="40" fill="url(#frm)" clipPath="url(#arch)"/>
      <path d="M10,46 L10,30 C10,19 19,13 24,13 C29,13 38,19 38,30 L38,46 Z" fill="none" stroke="url(#frm)" strokeWidth="3" clipPath="url(#arch)"/>
      <path d="M42,46 L42,30 C42,19 51,13 56,13 C61,13 70,19 70,30 L70,46 Z" fill="none" stroke="url(#frm)" strokeWidth="3" clipPath="url(#arch)"/>
      <rect x="29" y="48" width="3" height="46" fill="url(#frm)" clipPath="url(#arch)"/>
      <rect x="48" y="48" width="3" height="46" fill="url(#frm)" clipPath="url(#arch)"/>
      <path d="M10,94 L10,70 C10,60 14,56 19,56 C24,56 28,60 28,70 L28,94 Z" fill="none" stroke="url(#frm)" strokeWidth="2" clipPath="url(#arch)"/>
      <path d="M32,94 L32,70 C32,60 36,56 40,56 C44,56 48,60 48,70 L48,94 Z" fill="none" stroke="url(#frm)" strokeWidth="2" clipPath="url(#arch)"/>
      <path d="M51,94 L51,70 C51,60 55,56 60,56 C65,56 70,60 70,70 L70,94 Z" fill="none" stroke="url(#frm)" strokeWidth="2" clipPath="url(#arch)"/>
      <g clipPath="url(#arch)">
        <line x1="40" y1="20" x2="40" y2="3" stroke="#4A6830" strokeWidth="1.2" strokeLinecap="round"/>
        {[[37,17,-55],[43,17,55],[36.5,13,-55],[43.5,13,55],[36.5,9,-55],[43.5,9,55],[37,5.5,-55],[43,5.5,55]].map(([cx,cy,rot],i)=>(
          <ellipse key={i} cx={cx} cy={cy} rx={[3,3,2.8,2.8,2.6,2.6,2.3,2.3][i]} ry={[1.2,1.2,1.1,1.1,1,1,0.9,0.9][i]} fill={i%2===0?"#6A9040":"#82A850"} stroke="#3A5020" strokeWidth="0.6" transform={`rotate(${rot},${cx},${cy})`}/>
        ))}
        <ellipse cx="40" cy="3" rx="2" ry="0.85" fill="#6A9040" stroke="#3A5020" strokeWidth="0.6"/>
      </g>
      <path d="M9,94 L9,52 C9,24 9,18 40,8 C71,18 71,24 71,52 L71,94 Z" fill="none" stroke={frame} strokeWidth="4"/>
      <path d="M3,95 L3,50 C3,22 3,14 40,2 C77,14 77,22 77,50 L77,95 Z" fill="none" stroke="#3A1C0A" strokeWidth="1.2"/>
    </svg>
  );
}

function Badge({cat}){
  const s=CAT_STYLE[cat]||{bg:"#F3F0E8",text:"#5A4030",border:"#D8C8A0"};
  return <span style={{fontSize:11,fontFamily:"Inter,sans-serif",fontWeight:600,padding:"3px 10px",borderRadius:20,background:s.bg,color:s.text,border:`1px solid ${s.border}`,whiteSpace:"nowrap"}}>{cat}</span>;
}

function Avi({a,size=34}){
  if(a?.avatar_url){
    return <img src={a.avatar_url} alt={a.name} style={{width:size,height:size,borderRadius:"50%",objectFit:"cover",flexShrink:0,border:`1.5px solid ${a.color||"#b45309"}55`}}/>;
  }
  return <div style={{width:size,height:size,borderRadius:"50%",background:(a?.color||"#b45309")+"22",border:`1.5px solid ${(a?.color||"#b45309")}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*.33,fontWeight:600,color:a?.color||"#b45309",fontFamily:"Inter,sans-serif",flexShrink:0}}>{a?.initials||"?"}</div>;
}

function LangMenu({lang,setLang,D}){
  const [open,setOpen]=useState(false);
  const menuRef=useRef(null);
  useEffect(()=>{
    function handle(e){
      if(menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    }
    if(open) document.addEventListener("click",handle,true);
    return ()=>document.removeEventListener("click",handle,true);
  },[open]);
  const cur=LANGS.find(l=>l.code===lang)||LANGS[0];
  return(
    <div ref={menuRef} style={{position:"relative"}}>
      <button onClick={()=>setOpen(v=>!v)} style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:20,cursor:"pointer",color:D.TXT3,padding:"6px 10px",display:"flex",alignItems:"center",gap:5,fontSize:12,fontFamily:"Inter,sans-serif",lineHeight:1}}>
        <span>{cur.flag}</span>
        <span style={{maxWidth:55,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{cur.name}</span>
        <svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3l3 4 3-4"/></svg>
      </button>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 6px)",right:0,background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:12,boxShadow:"0 8px 24px rgba(0,0,0,0.15)",zIndex:999,minWidth:150,overflow:"hidden"}}>
          {LANGS.map(l=>(
            <button key={l.code} onClick={()=>{setLang(l.code);setOpen(false);}} style={{display:"flex",alignItems:"center",gap:9,width:"100%",padding:"9px 13px",background:lang===l.code?D.BDR:"transparent",border:"none",cursor:"pointer",color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",textAlign:"left"}}>
              <span>{l.flag}</span>
              <span style={{flex:1}}>{l.name}</span>
              {lang===l.code&&<span style={{color:"#d97706",fontSize:12}}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function StoryCard({post,onClick,compact,D,user}){
  const [liked,setLiked]=useState(false);
  const [saved,setSaved]=useState(false);
  const [likeLoading,setLikeLoading]=useState(false);
  const [saveLoading,setSaveLoading]=useState(false);

  useEffect(()=>{
    if(!user?.id||!post?.id) return;
    supabase.from("likes").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setLiked(true); });
    supabase.from("bookmarks").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setSaved(true); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  async function handleLike(e){
    e.stopPropagation();
    if(!user?.id||likeLoading) return;
    setLikeLoading(true);
    if(liked){
      await supabase.from("likes").delete().eq("user_id",user.id).eq("post_id",post.id);
      setLiked(false);
    } else {
      await supabase.from("likes").insert({user_id:user.id,post_id:post.id});
      setLiked(true);
    }
    setLikeLoading(false);
  }

  async function handleSave(e){
    e.stopPropagation();
    if(!user?.id||saveLoading) return;
    setSaveLoading(true);
    if(saved){
      await supabase.from("bookmarks").delete().eq("user_id",user.id).eq("post_id",post.id);
      setSaved(false);
    } else {
      await supabase.from("bookmarks").insert({user_id:user.id,post_id:post.id});
      setSaved(true);
    }
    setSaveLoading(false);
  }

  useEffect(()=>{
    if(!user||!post.id||!post.user_id&&post.is_anonymous) return;
    supabase.from("likes").select("id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setLiked(true); });
    supabase.from("bookmarks").select("id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setSaved(true); });
  },[user,post.id]);

  return(
    <article onClick={onClick} style={{background:D.CARD,borderRadius:12,border:`1px solid ${D.BDR}`,overflow:"hidden",cursor:"pointer",display:"flex",flexDirection:"column",transition:"transform .15s,box-shadow .15s",boxShadow:"0 1px 4px rgba(100,80,40,.06)"}}
      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 8px 24px rgba(100,80,40,.12)";}}
      onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="0 1px 4px rgba(100,80,40,.06)";}}>
      {post.coverImg&&<img src={post.coverImg} alt="" style={{width:"100%",height:compact?110:150,objectFit:"cover",display:"block"}}/>}
      <div style={{padding:compact?"14px":"20px",display:"flex",flexDirection:"column",gap:10,flex:1}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <Badge cat={post.category}/>
          <span style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.readTime} min</span>
        </div>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:compact?16:19,fontWeight:700,color:D.TXT,lineHeight:1.35,margin:0}}>{post.title}</h3>
        {!compact&&<p style={{fontSize:14,color:D.TXT3,lineHeight:1.7,fontFamily:"'Lora',Georgia,serif",margin:0}}>{post.excerpt}</p>}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:"auto",paddingTop:8}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <Avi a={post.author} size={26}/>
            <div>
              <div style={{fontSize:11,fontWeight:500,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{post.author.name}</div>
              <div style={{fontSize:10,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.date}</div>
            </div>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={handleLike} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:3,color:liked?"#e11d48":D.TXT3,fontSize:11,fontFamily:"Inter,sans-serif",padding:0}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill={liked?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              {fmt2(post.likes)}
            </button>
            <button onClick={handleSave} style={{background:"none",border:"none",cursor:"pointer",color:saved?"#d97706":D.TXT3,padding:0}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill={saved?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}

function HeroCard({post,onClick,D,t}){
  const s=CAT_STYLE[post.category]||{};
  return(
    <article onClick={onClick} style={{background:D.CARD,borderRadius:16,border:`1px solid ${D.BDR}`,overflow:"hidden",cursor:"pointer",boxShadow:"0 2px 12px rgba(100,80,40,.08)",transition:"transform .15s,box-shadow .15s"}}
      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 12px 36px rgba(100,80,40,.15)";}}
      onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="0 2px 12px rgba(100,80,40,.08)";}}>
      {post.coverImg&&<img src={post.coverImg} alt="" style={{width:"100%",height:200,objectFit:"cover",display:"block"}}/>}
      <div style={{padding:"28px 32px",position:"relative"}}>
        <div style={{position:"absolute",top:0,right:0,width:"40%",height:"100%",background:`linear-gradient(135deg,transparent 40%,${s.bg||BG} 100%)`,pointerEvents:"none"}}/>
        <div style={{position:"absolute",left:0,top:0,bottom:0,width:4,background:s.border||BORDER}}/>
        <div style={{position:"relative"}}>
          <div style={{display:"flex",gap:10,marginBottom:12,alignItems:"center"}}>
            <span style={{fontSize:11,fontFamily:"Inter,sans-serif",fontWeight:600,color:"#d97706",textTransform:"uppercase",letterSpacing:".06em"}}>{t.featured}</span>
            <Badge cat={post.category}/>
          </div>
          <h2 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:26,fontWeight:700,color:D.TXT,lineHeight:1.25,marginBottom:12}}>{post.title}</h2>
          <p style={{fontSize:15,color:D.TXT3,lineHeight:1.78,marginBottom:20,fontFamily:"'Lora',Georgia,serif"}}>{post.excerpt}</p>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <Avi a={post.author} size={38}/>
            <div>
              <div style={{fontSize:13,fontWeight:500,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{post.author.name}</div>
              <div style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.date} · {post.readTime} min</div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

function CommentThread({comment, allComments, depth=0, user, post, D, replyingTo, setReplyingTo, replyText, setReplyText, setComments}){
  const replies = allComments.filter(c=>c.parent_id===comment.id);
  return(
    <div style={{marginBottom: depth===0?16:8}}>
      <div style={{display:"flex",gap:10}}>
        <Avi a={comment.author} size={depth===0?32:26}/>
        <div style={{flex:1}}>
          <div style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:depth===0?13:12,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{comment.author.name}</span>
                <span style={{fontSize:10,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{comment.time}</span>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setReplyingTo(replyingTo===comment.id?null:comment.id)} style={{background:"none",border:"none",cursor:"pointer",fontSize:11,color:"#b45309",fontFamily:"Inter,sans-serif",padding:0,fontWeight:500}}>
                  {replyingTo===comment.id?"Cancel":"Reply"}
                </button>
                {comment.author.name===user?.name&&(
                  <button onClick={async()=>{
                    if(!window.confirm("Delete this comment?")) return;
                    await supabase.from("comments").delete().eq("id",comment.id);
                    setComments(cs=>cs.filter(c=>c.id!==comment.id&&c.parent_id!==comment.id));
                  }} style={{background:"none",border:"none",cursor:"pointer",fontSize:11,color:"#dc2626",fontFamily:"Inter,sans-serif",padding:0}}>Delete</button>
                )}
              </div>
            </div>
            <p style={{fontSize:depth===0?14:13,color:D.TXT3,lineHeight:1.65,fontFamily:"'Lora',Georgia,serif",margin:0}}>{comment.text}</p>
          </div>
          {replyingTo===comment.id&&(
            <div style={{display:"flex",gap:8,marginTop:8}}>
              <Avi a={{name:user?.name||"You",initials:user?.initials||"Y",color:user?.color||"#d97706"}} size={24}/>
              <div style={{flex:1}}>
                <textarea value={replyText} onChange={e=>setReplyText(e.target.value)} placeholder={`Reply to ${comment.author.name}...`} spellCheck={true} autoCorrect="on" style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"'Lora',Georgia,serif",resize:"none",minHeight:50,outline:"none",lineHeight:1.5}}/>
                {replyText.trim()&&(
                  <button onClick={async()=>{
                    const clean=sanitize(replyText);
                    if(containsBadWords(clean)){alert("Reply violates community guidelines.");return;}
                    const {data:nr}=await supabase.from("comments").insert({
                      post_id:comment.post_id||post.id,user_id:user?.id,
                      parent_id:comment.id,text:clean,
                      author_name:user?.name||"Anonymous",
                      author_initials:user?.initials||"A",
                      author_color:user?.color||"#b45309"
                    }).select().single();
                    setComments(cs=>[...cs,{id:nr?.id||Date.now(),parent_id:comment.id,post_id:post.id,text:clean,time:"Just now",author:{name:user?.name||"Anonymous",initials:user?.initials||"A",color:user?.color||"#b45309"}}]);
                    setReplyText(""); setReplyingTo(null);
                    // Send email to person being replied to
                    if(comment.user_id&&comment.user_id!==user?.id){
                      const {data:replyProfile} = await supabase.from("profiles").select("email").eq("id",comment.user_id).single();
                      if(replyProfile?.email){
                        sendNotificationEmail({
                          to: replyProfile.email,
                          subject: `${user?.name||"Someone"} replied to your comment`,
                          html: commentEmailHTML(user?.name||"Someone", post.title, clean)
                        });
                      }
                    }
                  }} style={{marginTop:4,padding:"5px 12px",background:"#2C1E0E",color:"#FFFCF4",border:"none",borderRadius:20,cursor:"pointer",fontSize:11,fontFamily:"Inter,sans-serif",fontWeight:500}}>Post Reply</button>
                )}
              </div>
            </div>
          )}
          {replies.length>0&&(
            <div style={{marginTop:8,paddingLeft:12,borderLeft:"2px solid #E8DBBF"}}>
              {replies.map(reply=>(
                <CommentThread key={reply.id} comment={reply} allComments={allComments} depth={depth+1} user={user} post={post} D={D} replyingTo={replyingTo} setReplyingTo={setReplyingTo} replyText={replyText} setReplyText={setReplyText} setComments={setComments}/>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function PostDetail({post,onBack,D,t,user,setViewingUser,fontSize,setFontSize,dark}){
  const [liked,setLiked]=useState(false);
  const [saved,setSaved]=useState(false);
  const [comment,setComment]=useState("");
  const [likeLoading,setLikeLoading]=useState(false);
  const [saveLoading,setSaveLoading]=useState(false);


  useEffect(()=>{
    if(!user?.id) return;
    supabase.from("group_members")
      .select("group_id, groups(id,name,church)")
      .eq("user_id",user.id)
      .then(({data})=>{ if(data) setUserGroups(data.map(m=>m.groups).filter(Boolean)); });
    supabase.from("group_posts")
      .select("group_id")
      .eq("post_id",post.id)
      .then(({data})=>{ if(data) setSharedGroups(data.map(g=>g.group_id)); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const [following,setFollowing]=useState(false);
  const [showReport,setShowReport]=useState(false);
  const [showEdit,setShowEdit]=useState(false);
  const [editTitle,setEditTitle]=useState(post.title);
  const [editContent,setEditContent]=useState(post.content);
  const [showGroupShare,setShowGroupShare]=useState(false);

  const [userGroups,setUserGroups]=useState([]);
  const [sharedGroups,setSharedGroups]=useState([]);

  useEffect(()=>{
    setShowGroupShare(false);
    setShowReport(false);
    if(!user?.id) return;
    supabase.from("group_members")
      .select("group_id, groups(id,name,church)")
      .eq("user_id",user.id)
      .then(({data})=>{ if(data) setUserGroups(data.map(m=>m.groups).filter(Boolean)); });
    supabase.from("group_posts")
      .select("group_id")
      .eq("post_id",post.id)
      .then(({data})=>{ if(data) setSharedGroups(data.map(g=>g.group_id)); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(!user?.id||!post?.user_id||post.user_id===user?.id) return;
    supabase.from("follows").select("*").eq("follower_id",user.id).eq("following_id",post.user_id)
      .then(({data})=>{ if(data&&data.length>0) setFollowing(true); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(!user?.id||!post?.id) return;
    supabase.from("likes").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setLiked(true); });
    supabase.from("bookmarks").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setSaved(true); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  async function handleDetailLike(){
    if(!user?.id||likeLoading) return;
    setLikeLoading(true);
    if(liked){
      await supabase.from("likes").delete().eq("user_id",user.id).eq("post_id",post.id);
      setLiked(false);
    } else {
     await supabase.from("likes").insert({user_id:user.id,post_id:post.id});
      setLiked(true);
      // Send email notification
      if(post.user_id!==user?.id){
        const {data:authorProfile} = await supabase.from("profiles").select("email").eq("id",post.user_id).single();
        if(authorProfile?.email){
          sendNotificationEmail({
            to: authorProfile.email,
            subject: `${user?.name||"Someone"} liked your testimony`,
            html: likeEmailHTML(user?.name||"Someone", post.title)
          });
        }
      }
    }
    setLikeLoading(false);
  }

  async function handleDetailSave(){
    if(!user?.id||saveLoading) return;
    setSaveLoading(true);
    if(saved){
      await supabase.from("bookmarks").delete().eq("user_id",user.id).eq("post_id",post.id);
      setSaved(false);
    } else {
      await supabase.from("bookmarks").insert({user_id:user.id,post_id:post.id});
      setSaved(true);
    }
    setSaveLoading(false);
  }

  useEffect(()=>{
    if(!post?.id||!user?.id) return;
    supabase.from("likes").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setLiked(true); });
    supabase.from("bookmarks").select("post_id").eq("user_id",user.id).eq("post_id",post.id)
      .then(({data})=>{ if(data&&data.length>0) setSaved(true); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const [replyingTo,setReplyingTo]=useState(null);
  const [replyText,setReplyText]=useState("");
  const [comments,setComments]=useState([]);

  useEffect(()=>{
    if(!post?.id) return;
    supabase.from("comments")
      .select("*")
      .eq("post_id",post.id)
      .order("created_at",{ascending:true})
      .then(({data})=>{
        if(data&&data.length>0){
          setComments(data.map(c=>({
            id:        c.id,
            parent_id: c.parent_id||null,
            text:      c.text,
            time:      new Date(c.created_at).toLocaleDateString("en-US",{month:"long",day:"numeric"}),
            author:{
              name:     c.author_name||"Anonymous",
              initials: c.author_initials||"A",
              color:    c.author_color||"#b45309"
            }
          })));
        }
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[post?.id]);
  const s=CAT_STYLE[post.category]||{};
  const paras=post.content.split("\n\n");
  return(
    <div style={{maxWidth:720,margin:"0 auto",padding:"0 16px 64px",background:D.BG,boxSizing:"border-box"}}>
      <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:6,color:D.TXT3,fontSize:13,fontFamily:"Inter,sans-serif",padding:"22px 0"}}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        {t.back}
      </button>
      {(!post.is_anonymous&&post.user_id===user?.id)&&(
        <div style={{display:"flex",gap:8,marginBottom:8}}>
        <button onClick={async()=>{
          if(!window.confirm("Delete this story? This cannot be undone.")) return;
          const {error} = await supabase.from("posts").delete().eq("id",post.id);
          if(!error){ onBack(); }
          else { alert("Error: "+error.message); }
        }} style={{background:"none",border:"1px solid #FECACA",borderRadius:20,cursor:"pointer",color:"#dc2626",padding:"6px 14px",fontSize:12,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:5}}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          Delete Story
        </button>
        <button onClick={()=>setShowEdit(true)} style={{background:"none",border:"1px solid #E8DBBF",borderRadius:20,cursor:"pointer",color:D.TXT3,padding:"6px 14px",fontSize:12,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:5}}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
         Edit Story
        </button>
        </div>
      )}
      {showEdit&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:D.CARD,borderRadius:16,border:`1px solid ${D.BDR}`,padding:"28px",maxWidth:600,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,0.25)",maxHeight:"80vh",overflowY:"auto"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
              <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,color:D.TXT,margin:0}}>Edit Story</h3>
              <button onClick={()=>setShowEdit(false)} style={{background:"none",border:"none",cursor:"pointer",color:D.TXT3}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <input value={editTitle} onChange={e=>setEditTitle(e.target.value)} placeholder="Title" style={{width:"100%",fontSize:20,fontFamily:"'Playfair Display',Georgia,serif",fontWeight:700,color:D.TXT,border:"none",borderBottom:`2px solid ${D.BDR}`,outline:"none",background:"transparent",marginBottom:16,paddingBottom:8,boxSizing:"border-box"}}/>
            <textarea value={editContent} onChange={e=>setEditContent(e.target.value)} placeholder="Your testimony..." style={{width:"100%",fontSize:15,fontFamily:"'Lora',Georgia,serif",color:D.TXT,border:`1px solid ${D.BDR}`,borderRadius:8,outline:"none",background:D.BG,resize:"none",minHeight:300,padding:"12px 14px",lineHeight:1.8,boxSizing:"border-box",marginBottom:16}}/>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button onClick={()=>setShowEdit(false)} style={{padding:"9px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Cancel</button>
              <button onClick={async()=>{
                if(!editTitle.trim()||!editContent.trim()) return;
                const {error} = await supabase.from("posts").update({title:editTitle,content:editContent}).eq("id",post.id);
                if(!error){
                  post.title = editTitle;
                  post.content = editContent;
                  setShowEdit(false);
                  alert("Story updated successfully!");
                } else {
                  alert("Error updating story: "+error.message);
                }
              }} style={{padding:"9px 20px",borderRadius:20,border:"none",background:"#2C1E0E",color:"#FFFCF4",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:600}}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
      {showReport&&<ReportModal target={post.title} onClose={()=>setShowReport(false)} D={D}/>}
      {showGroupShare&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:D.CARD,borderRadius:16,border:`1px solid ${D.BDR}`,padding:"28px",maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,0.25)"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
              <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,color:D.TXT,margin:0}}>Share to Group</h3>
              <button onClick={()=>setShowGroupShare(false)} style={{background:"none",border:"none",cursor:"pointer",color:D.TXT3}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            {userGroups.length===0?(
              <p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7}}>You are not in any groups yet. Go to Groups in the nav to create or join one.</p>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {userGroups.map(g=>{
                  const shared = sharedGroups.includes(g.id);
                  return(
                    <div key={g.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:D.BG,borderRadius:10,border:`1px solid ${shared?"#6EE7B7":D.BDR}`}}>
                      <span style={{fontSize:20}}>⛪</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:14,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{g.name}</div>
                        {g.church&&<div style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{g.church}</div>}
                      </div>
                      <button onClick={async()=>{
                        if(shared){
                          await supabase.from("group_posts").delete().eq("group_id",g.id).eq("post_id",post.id);
                          setSharedGroups(s=>s.filter(id=>id!==g.id));
                        } else {
                          await supabase.from("group_posts").insert({group_id:g.id,post_id:post.id});
                          setSharedGroups(s=>[...s,g.id]);
                        }
                      }} style={{padding:"6px 14px",borderRadius:20,border:`1px solid ${shared?"#34D399":D.BDR}`,background:shared?"#ECFDF5":"transparent",color:shared?"#065F46":D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif",fontWeight:shared?600:400}}>
                        {shared?"Shared ✓":"Share"}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            <button onClick={()=>setShowGroupShare(false)} style={{width:"100%",marginTop:16,padding:"10px",borderRadius:10,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>Done</button>
          </div>
        </div>
      )}
      {post.coverImg&&<div style={{marginBottom:24,borderRadius:12,overflow:"hidden"}}><img src={post.coverImg} alt="" style={{width:"100%",maxHeight:360,objectFit:"cover",display:"block"}}/></div>}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
        <Badge cat={post.category}/>
        {post.tags.map(tg=><span key={tg} style={{fontSize:11,fontFamily:"Inter,sans-serif",color:D.TXT3,padding:"3px 8px",borderRadius:20,border:`1px solid ${D.BDR}`}}>#{tg}</span>)}
      </div>
      <h1 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:34,fontWeight:700,color:D.TXT,lineHeight:1.2,marginBottom:20}}>{post.title}</h1>
      <div style={{display:"flex",alignItems:"center",gap:12,paddingBottom:22,borderBottom:`1px solid ${D.BDR}`,marginBottom:28}}>
        <Avi a={post.author} size={42}/>
        <div style={{flex:1}}>
          <div onClick={async()=>{
               
               if(post.is_anonymous||!post.user_id||post.user_id===user?.id) return;
                const {data} = await supabase.from("profiles").select("*").eq("id",post.user_id).single();
                if(data){ setViewingUser(data); }
              }} style={{fontSize:14,fontWeight:500,color:D.TXT,fontFamily:"Inter,sans-serif",cursor:post.user_id!==user?.id?"pointer":"default",textDecoration:post.user_id!==user?.id?"underline":"none"}}>{post.author.name}</div>
          <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif",marginTop:2}}>{post.date} · {post.readTime} min</div>
        </div>
        {post.user_id!==user?.id&&(
          <button onClick={async()=>{
            if(following){
              await supabase.from("follows").delete().eq("follower_id",user.id).eq("following_id",post.user_id);
              setFollowing(false);
            } else {
              await supabase.from("follows").insert({follower_id:user.id,following_id:post.user_id});
              setFollowing(true);
              
            }
          }} style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${following?"#b45309":D.BDR}`,background:following?"#FEF3C7":"transparent",color:following?"#92400E":D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif",fontWeight:following?600:400,flexShrink:0}}>
            {following?"Following ✓":"Follow"}
          </button>
        )}
        <div className="action-bar" style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button onClick={handleDetailLike} disabled={likeLoading} style={{display:"flex",alignItems:"center",gap:5,padding:"8px 14px",borderRadius:20,border:`1.5px solid ${liked?"#e11d48":D.BDR}`,background:liked?"#fff1f2":D.CARD,color:liked?"#e11d48":D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill={liked?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            {fmt2(post.likes+(liked?1:0))}
          </button>
          <button onClick={handleDetailSave} disabled={saveLoading} style={{display:"flex",alignItems:"center",gap:5,padding:"8px 14px",borderRadius:20,border:`1.5px solid ${saved?"#d97706":D.BDR}`,background:saved?"#fffbeb":D.CARD,color:saved?"#d97706":D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill={saved?"currentColor":"none"} stroke="currentColor" strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
            {t.save}
          </button>
          <button onClick={()=>{
            const url = window.location.href;
            if(navigator.share){
              navigator.share({
                title: post.title,
                text: post.excerpt,
                url: url
              });
            } else {
              navigator.clipboard.writeText(url);
              alert("Link copied to clipboard!");
            }
        }} style={{display:"flex",alignItems:"center",gap:5,padding:"8px 14px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.CARD,color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
            Share
          </button>
          <button onClick={()=>setShowGroupShare(true)} style={{display:"flex",alignItems:"center",gap:5,padding:"8px 14px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.CARD,color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
           Share to Group
          </button>
          <button onClick={()=>setShowReport(true)} style={{display:"flex",alignItems:"center",gap:5,padding:"8px 14px",borderRadius:20,border:`1px solid #FECACA`,background:"transparent",color:"#dc2626",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            Report
          </button>
        </div>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:16,justifyContent:"flex-end"}}>
        <span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>Text size:</span>
        {[["small","A",13],["medium","A",16],["large","A",19],["xl","A",22]].map(([size,label,fs])=>(
          <button key={size} onClick={()=>setFontSize(size)} style={{width:32,height:32,borderRadius:"50%",border:`1.5px solid ${fontSize===size?"#b45309":D.BDR}`,background:fontSize===size?"#FEF3C7":D.CARD,color:fontSize===size?"#92400E":D.TXT3,cursor:"pointer",fontSize:fs,fontFamily:"'Playfair Display',serif",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",padding:0}}>
            {label}
          </button>
        ))}
      </div>
      <div style={{fontSize:fontSize==="small"?15:fontSize==="large"?21:fontSize==="xl"?24:18,color:D.TXT2,lineHeight:1.88,fontFamily:"'Lora',Georgia,serif"}}>
        {paras.map((p,i)=>{
          if(!p.trim()) return null;
          const imgMatch = p.trim().match(/^\[img:(\d+)\]$/);
          if(imgMatch){
            const imgId = parseInt(imgMatch[1]);
            const img = (post.bodyImgs||[]).find(x=>x.id===imgId);
            return img ? <img key={i} src={img.src} alt="" style={{width:"100%",maxHeight:400,objectFit:"cover",borderRadius:10,margin:"8px 0 24px",display:"block"}}/> : null;
          }
          return <p key={i} style={{marginBottom:22}} dangerouslySetInnerHTML={{__html:p.replace(/\*(.*?)\*/g,'<em style="font-style:italic;font-weight:500;">$1</em>')}}/>;
        })}
      </div>
      
      <div style={{margin:"40px 0",padding:"22px 26px",background:dark?(s.bg?"#2A2018":"#2A2018"):s.bg||"#F5EDD8",borderLeft:`4px solid ${s.border||BORDER}`,borderRadius:"0 8px 8px 0"}}>
        <p style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:17,fontStyle:"italic",color:D.TXT,lineHeight:1.65,textAlign:"center"}}>"{t.jer}"</p>
        <p style={{fontSize:12,color:D.TXT3,marginTop:8,textAlign:"center",fontFamily:"Inter,sans-serif"}}>{t.jerRef}</p>
      </div>
      <div style={{borderTop:`1px solid ${D.BDR}`,paddingTop:28}}>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:22}}>{comments.length} {t.responses}</h3>
        <div style={{display:"flex",gap:12,marginBottom:20}}>
          <Avi a={{name:"You",initials:"Y",color:"#d97706"}} size={34}/>
          <div style={{flex:1}}>
            <textarea value={comment} onChange={e=>setComment(e.target.value)} placeholder={t.commentHint} spellCheck={true} autoCorrect="on" autoCapitalize="sentences" style={{width:"100%",padding:"12px 14px",borderRadius:10,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:14,fontFamily:"'Lora',Georgia,serif",resize:"none",minHeight:80,outline:"none",lineHeight:1.7}}/>
            {comment.trim()&&<button onClick={async()=>{const cleanComment=sanitize(comment);
            if(containsBadWords(cleanComment)){alert("Your comment contains some words that aren't allowed. Please keep all responses kind and faith-centered.");return;}
            const {error} = await supabase.from("comments").insert({
              post_id:         post.id,
              user_id:         user?.id,
              text:            cleanComment,
              author_name:     user?.name||"Anonymous",
              author_initials: user?.initials||"A",
              author_color:    user?.color||"#b45309"
            });
            if(!error){
              setComments(cs=>[{id:Date.now(),author:{name:user?.name||"Anonymous",initials:user?.initials||"A",color:user?.color||"#b45309"},text:cleanComment,time:"Just now"},...cs]);
              setComment("");
              if(post.user_id!==user?.id){
                const {data:authorProfile} = await supabase.from("profiles").select("email").eq("id",post.user_id).single();
               if(authorProfile?.email){
                  console.log("SENDING EMAIL TO:", authorProfile.email);
                  sendNotificationEmail({
                    to: authorProfile.email,
                    subject: `${user?.name||"Someone"} commented on your testimony`,
                    html: commentEmailHTML(user?.name||"Someone", post.title, cleanComment)
                 });
                }
              }
            }
          }} style={{marginTop:8,padding:"9px 18px",background:"#2C1E0E",color:"#FFFCF4",border:"none",borderRadius:20,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>{t.postResp}</button>}
          </div>
        </div>
        {comments.filter(c=>!c.parent_id).map(c=>(
          <CommentThread key={c.id} comment={c} allComments={comments} depth={0} user={user} post={post} D={D} replyingTo={replyingTo} setReplyingTo={setReplyingTo} replyText={replyText} setReplyText={setReplyText} setComments={setComments}/>
        ))}
      </div>
    </div>
  );
}

function WritePost({onPublish,onBack,D,t,user,draft}){
  const [title,setTitle]=useState(draft?.title||""),[content,setContent]=useState(draft?.content||""),[cat,setCat]=useState(draft?.category||"Jesus");
  const [saved,setSaved]=useState(false),[coverImg,setCoverImg]=useState(draft?.cover_img||null),[bodyImgs,setBodyImgs]=useState(()=>{try{return draft?.body_imgs?JSON.parse(draft.body_imgs):[];}catch(e){return[];}});
  const [anonymous,setAnonymous]=useState(draft?.is_anonymous||false);
  const [draftId,setDraftId]=useState(draft?.id||null);
  const coverRef=useRef(),bodyRef=useRef();
  const words=content.trim()?content.trim().split(/\s+/).length:0;
  const loadImg=(file,cb)=>{if(!file||!file.type.startsWith("image/"))return;const r=new FileReader();r.onload=e=>cb(e.target.result);r.readAsDataURL(file);};
  const addBody=src=>{const id=Date.now();setBodyImgs(p=>[...p,{id,src}]);setContent(p=>p+"\n\n[img:"+id+"]\n\n");};
  return(
    <div style={{maxWidth:720,margin:"0 auto",padding:"0 16px 64px",background:D.BG,boxSizing:"border-box"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"22px 0 20px"}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:D.TXT3,fontSize:13,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:6}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          {t.cancel}
        </button>
        <div style={{display:"flex",gap:8}}>
          <button onClick={async()=>{
              if(!title.trim()&&!content.trim()) return;
              const draftData = {
                user_id: user?.id,
                title: title||"Untitled",
                content: content,
                category: cat,
                cover_img: coverImg||"",
                body_imgs: JSON.stringify(bodyImgs||[]),
                is_anonymous: anonymous,
                updated_at: new Date().toISOString()
              };
              let error;
              if(draftId){
                ({error} = await supabase.from("drafts").update(draftData).eq("id",draftId));
              } else {
                const {data:newDraft, error:insertError} = await supabase.from("drafts").insert(draftData).select().single();
                error = insertError;
                if(newDraft) setDraftId(newDraft.id);
              }
              if(!error) setSaved(true);
            }} style={{padding:"9px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.CARD,color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>{t.draft}</button>
          <button disabled={!title.trim()||!content.trim()} onClick={()=>title.trim()&&content.trim()&&onPublish({title,content,cat,coverImg,bodyImgs,anonymous})} style={{padding:"9px 18px",borderRadius:20,border:"none",background:title.trim()&&content.trim()?D.PUBBG:D.BDR,color:title.trim()&&content.trim()?D.PUB:D.TXT3,cursor:title.trim()&&content.trim()?"pointer":"default",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>{t.publish}</button>
        </div>
      </div>
      {saved&&<div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:13,color:"#92400E",fontFamily:"Inter,sans-serif"}}>Draft saved</div>}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:18,paddingBottom:14,borderBottom:`1px solid ${D.BDR}`}}>
        <button type="button" onClick={()=>coverRef.current.click()} style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:8,cursor:"pointer",color:D.TXT3,padding:"6px 12px",fontSize:12,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:5}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
          {coverImg?t.changeCover:t.addCover}
        </button>
        <button type="button" onClick={()=>bodyRef.current.click()} style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:8,cursor:"pointer",color:D.TXT3,padding:"6px 12px",fontSize:12,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:5}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          {t.insertImg}
        </button>
        <span style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif",alignSelf:"center",fontStyle:"italic"}}>{t.pasteHint}</span>
      </div>
      <input ref={coverRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>loadImg(e.target.files[0],setCoverImg)}/>
      <input ref={bodyRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>loadImg(e.target.files[0],addBody)}/>
      {coverImg&&<div style={{position:"relative",marginBottom:22,borderRadius:10,overflow:"hidden"}}><img src={coverImg} alt="" style={{width:"100%",maxHeight:260,objectFit:"cover",display:"block"}}/><button onClick={()=>setCoverImg(null)} style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,.55)",color:"white",border:"none",borderRadius:20,cursor:"pointer",padding:"4px 12px",fontSize:12}}>{t.remove}</button></div>}
      <label style={{display:"flex",alignItems:"center",gap:10,marginBottom:20,cursor:"pointer"}}>
        <input type="checkbox" checked={anonymous} onChange={e=>setAnonymous(e.target.checked)} style={{accentColor:"#b45309",width:16,height:16}}/>
        <div>
          <span style={{fontSize:13,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>Post anonymously</span>
          <span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif",marginLeft:8}}>Your name will be hidden</span>
        </div>
      </label>
      <select value={cat} onChange={e=>setCat(e.target.value)} style={{padding:"8px 14px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.CARD,color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",marginBottom:20,cursor:"pointer"}}>
        {CATS.filter(c=>c!=="All").map(c=><option key={c} value={c}>{c}</option>)}
      </select>
      <textarea value={title} onChange={e=>setTitle(e.target.value)} placeholder={t.titleHint} spellCheck={true} autoCorrect="on" autoCapitalize="sentences" style={{width:"100%",fontSize:28,fontFamily:"'Playfair Display',Georgia,serif",fontWeight:700,color:D.TXT,border:"none",outline:"none",background:"transparent",resize:"none",lineHeight:1.25,borderBottom:`1px solid ${D.BDR}`,paddingBottom:16,marginBottom:22}} rows={2}/>
      <textarea value={content} onChange={e=>setContent(e.target.value)} onPaste={e=>{for(const item of (e.clipboardData?e.clipboardData.items:[])){if(item.type.startsWith("image/"))loadImg(item.getAsFile(),addBody);}}} placeholder={t.bodyHint} spellCheck={true} autoCorrect="on" autoCapitalize="sentences" style={{width:"100%",fontSize:17,fontFamily:"'Lora',Georgia,serif",color:D.TXT,border:"none",outline:"none",background:"transparent",resize:"none",lineHeight:1.88,minHeight:400}}/>
      {bodyImgs.length>0&&<div style={{marginTop:14,display:"flex",flexDirection:"column",gap:10}}>{bodyImgs.map(img=><div key={img.id} style={{position:"relative",borderRadius:10,overflow:"hidden",border:`1px solid ${D.BDR}`}}><img src={img.src} alt="" style={{width:"100%",maxHeight:320,objectFit:"cover",display:"block"}}/><button onClick={()=>{setBodyImgs(p=>p.filter(x=>x.id!==img.id));setContent(p=>p.replace("\n\n[img:"+img.id+"]\n\n",""));}} style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,.55)",color:"white",border:"none",borderRadius:20,cursor:"pointer",padding:"4px 12px",fontSize:12}}>{t.remove}</button></div>)}</div>}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:16,paddingTop:12,borderTop:`1px solid ${D.BDR}`}}>
        <div style={{display:"flex",gap:16}}>
          <span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}><b style={{color:D.TXT}}>{words.toLocaleString()}</b> {t.words}</span>
          {words>0&&<span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>~<b style={{color:D.TXT}}>{Math.ceil(words/200)}</b> {t.minRead}</span>}
        </div>
        <span style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif",fontStyle:"italic"}}>{t.noLimit}</span>
      </div>
    </div>
  );
}

function OnboardingPage({onDone, D}){
  const [page, setPage] = useState(0);
  const slides = [
    {emoji:"🕊️",title:"Welcome to My Testimony",body:"A space for Christians to share how God has moved in their lives. Every story matters. Every testimony has power.",color:"#FEF3C7"},
    {emoji:"✍️",title:"Share Your Story",body:"Write about healing, salvation, answered prayer, or any moment God showed up. Post anonymously if you prefer.",color:"#F0FDF4"},
    {emoji:"❤️",title:"Encourage Others",body:"Like, comment, and reply to testimonies. Follow people whose stories speak to you. Build community.",color:"#FFF1F2"},
    {emoji:"⛪",title:"Church Groups",body:"Create or join a private group for your church. Share testimonies and chat with your community.",color:"#EFF6FF"},
    {emoji:"🔥",title:"Build a Reading Streak",body:"Read testimonies every day and build your streak. Let faith stories inspire your daily walk.",color:"#FEF3C7"}
  ];
  const slide = slides[page];
  return(
    <div style={{minHeight:"100vh",background:"#F5EDD8",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24}}>
      <style>{FONTS}</style>
      <div style={{maxWidth:480,width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <Logo size={52}/>
        </div>
        <div style={{background:slide.color,borderRadius:24,padding:"40px 32px",marginBottom:24,minHeight:280,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",transition:"all .3s"}}>
          <div style={{fontSize:56,marginBottom:20}}>{slide.emoji}</div>
          <h2 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:26,fontWeight:700,color:"#2C1E0E",marginBottom:16,lineHeight:1.3}}>{slide.title}</h2>
          <p style={{fontSize:16,color:"#5A3E28",fontFamily:"'Lora',Georgia,serif",lineHeight:1.75}}>{slide.body}</p>
        </div>
        <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:24}}>
          {slides.map((_,i)=>(
            <div key={i} onClick={()=>setPage(i)} style={{width:page===i?24:8,height:8,borderRadius:4,background:page===i?"#2C1E0E":"#D9CDAB",cursor:"pointer",transition:"all .3s"}}/>
          ))}
        </div>
        <div style={{display:"flex",gap:12}}>
          {page>0&&(
            <button onClick={()=>setPage(p=>p-1)} style={{flex:1,padding:"14px",borderRadius:12,border:"1px solid #E8DBBF",background:"transparent",color:"#5A3E28",cursor:"pointer",fontSize:15,fontFamily:"Inter,sans-serif"}}>Back</button>
          )}
          {page<slides.length-1?(
            <button onClick={()=>setPage(p=>p+1)} style={{flex:1,padding:"14px",borderRadius:12,border:"none",background:"#2C1E0E",color:"#FFFCF4",cursor:"pointer",fontSize:15,fontFamily:"Inter,sans-serif",fontWeight:600}}>Next</button>
          ):(
            <button onClick={onDone} style={{flex:1,padding:"14px",borderRadius:12,border:"none",background:"#2C1E0E",color:"#FFFCF4",cursor:"pointer",fontSize:15,fontFamily:"'Playfair Display',Georgia,serif",fontWeight:700}}>Get Started →</button>
          )}
        </div>
        <div style={{textAlign:"center",marginTop:16}}>
          <button onClick={onDone} style={{background:"none",border:"none",cursor:"pointer",color:"#A89070",fontSize:13,fontFamily:"Inter,sans-serif"}}>Skip</button>
        </div>
      </div>
    </div>
  );
}



// ── Safety & Moderation Layer ─────────────────────────────────────────────────

// 1. Profanity / harmful content filter (expandable word list)
const BAD_WORDS = ["fuck","shit","bitch","asshole","damn","cunt","bastard","nigger","faggot","whore","slut","kill yourself","kys","rape","molest"];
function containsBadWords(text) {
  const lower = text.toLowerCase();
  return BAD_WORDS.some(w => lower.includes(w));
}

// 2. Strip dangerous HTML / script injection from any user text
function sanitize(str) {
  return str
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/<[^>]+>/g, "")           // strip all HTML tags
    .replace(/javascript:/gi, "")       // remove js: protocol
    .replace(/on\w+\s*=/gi, "")         // remove event handlers
    .trim();
}

// 3. Password strength checker
function passwordStrength(pw) {
  let score = 0;
  if (pw.length >= 8)  score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  if (score <= 1) return { label:"Weak",   color:"#ef4444", width:"20%" };
  if (score <= 2) return { label:"Fair",   color:"#f97316", width:"45%" };
  if (score <= 3) return { label:"Good",   color:"#eab308", width:"65%" };
  if (score <= 4) return { label:"Strong", color:"#22c55e", width:"85%" };
  return               { label:"Very strong", color:"#16a34a", width:"100%" };
}

// 4. Rate limiter (max 5 failed logins → 30s lockout)
const loginAttempts = { count: 0, lockedUntil: 0 };
function recordFailedLogin() {
  loginAttempts.count++;
  if (loginAttempts.count >= 5) {
    loginAttempts.lockedUntil = Date.now() + 30000;
    loginAttempts.count = 0;
  }
}
function isLockedOut() { return Date.now() < loginAttempts.lockedUntil; }

// 5. Report reasons
const REPORT_REASONS = [
  "Inappropriate or offensive content",
  "Harassment or bullying",
  "False or misleading testimony",
  "Spam or self-promotion",
  "Hate speech or discrimination",
  "Content involving a minor",
  "Other",
];

// ── Report Modal ──────────────────────────────────────────────────────────────
function ReportModal({ target, onClose, D }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [done, setDone] = useState(false);

  function submit() {
    if (!reason) return;
    // In production this would POST to your moderation API
    sendNotificationEmail({
      to: "support@mytestimonyapp.com",
      subject: `⚠️ Content Report: ${reason}`,
      html: reportEmailHTML("A user", reason, details, target||"Unknown post")
    });
    setDone(true);
  }

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:D.CARD, borderRadius:16, border:`1px solid ${D.BDR}`, padding:"28px", maxWidth:420, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
        {done ? (
          <div style={{ textAlign:"center", padding:"16px 0" }}>
            <div style={{ fontSize:36, marginBottom:12 }}>✅</div>
            <h3 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:20, color:D.TXT, marginBottom:8 }}>Report Submitted</h3>
            <p style={{ fontSize:14, color:D.TXT3, fontFamily:"'Lora',Georgia,serif", lineHeight:1.7, marginBottom:20 }}>
              Thank you. Our moderation team will review this content and take appropriate action within 24 hours.
            </p>
            <button onClick={onClose} style={{ padding:"10px 24px", borderRadius:20, background:"#2C1E0E", color:"#FFFCF4", border:"none", cursor:"pointer", fontSize:13, fontFamily:"Inter,sans-serif" }}>Done</button>
          </div>
        ) : (
          <>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
              <h3 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:20, color:D.TXT, margin:0 }}>Report Content</h3>
              <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:D.TXT3, padding:4 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <p style={{ fontSize:13, color:D.TXT3, fontFamily:"Inter,sans-serif", marginBottom:16 }}>Select the reason for your report:</p>
            <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
              {REPORT_REASONS.map(r => (
                <label key={r} style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer", padding:"8px 12px", borderRadius:8, background:reason===r?`#FEF3C7`:"transparent", border:`1px solid ${reason===r?"#FCD34D":D.BDR}`, transition:"all .15s" }}>
                  <input type="radio" name="reason" value={r} checked={reason===r} onChange={()=>setReason(r)} style={{ accentColor:"#b45309" }}/>
                  <span style={{ fontSize:13, color:D.TXT, fontFamily:"Inter,sans-serif" }}>{r}</span>
                </label>
              ))}
            </div>
            <textarea value={details} onChange={e=>setDetails(e.target.value)} placeholder="Additional details (optional)..." style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:`1px solid ${D.BDR}`, background:D.BG, color:D.TXT, fontSize:13, fontFamily:"'Lora',Georgia,serif", resize:"none", minHeight:70, outline:"none", boxSizing:"border-box", marginBottom:16 }}/>
            <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
              <button onClick={onClose} style={{ padding:"9px 18px", borderRadius:20, border:`1px solid ${D.BDR}`, background:"transparent", color:D.TXT3, cursor:"pointer", fontSize:13, fontFamily:"Inter,sans-serif" }}>Cancel</button>
              <button onClick={submit} disabled={!reason} style={{ padding:"9px 18px", borderRadius:20, border:"none", background:reason?"#dc2626":"#D0C8B8", color:"white", cursor:reason?"pointer":"default", fontSize:13, fontFamily:"Inter,sans-serif", fontWeight:500 }}>Submit Report</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── Community Guidelines Banner (shown once after signup) ─────────────────────
function GuidelinesBanner({ onAccept }) {
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#FFFCF4", borderRadius:16, border:"1px solid #E8DBBF", padding:"32px", maxWidth:480, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.2)", maxHeight:"90vh", overflowY:"auto" }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ fontSize:36, marginBottom:8 }}>🕊️</div>
          <h2 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:22, color:"#2C1E0E", marginBottom:8 }}>Community Guidelines</h2>
          <p style={{ fontSize:14, color:"#A89070", fontFamily:"'Lora',Georgia,serif", lineHeight:1.65 }}>My Testimony is a sacred space. Please read and agree before continuing.</p>
        </div>
        {[
          { icon:"✝️", title:"Keep it faith-centered", desc:"Share genuine testimonies of God's work in your life. This is not a general social media platform." },
          { icon:"❤️", title:"Speak with love", desc:"No harassment, hate speech, bullying, or content intended to harm others. Disagree with grace." },
          { icon:"🔒", title:"Protect privacy", desc:"Do not share personal information about others without their consent." },
          { icon:"🛡️", title:"No harmful content", desc:"No content promoting self-harm, violence, abuse, or illegal activity of any kind." },
          { icon:"🧒", title:"Protect children", desc:"No content that exploits, endangers, or is inappropriate for minors." },
          { icon:"📖", title:"Be authentic", desc:"Your testimony should be your real experience. Do not fabricate stories or impersonate others." },
        ].map(g => (
          <div key={g.title} style={{ display:"flex", gap:14, padding:"14px 0", borderBottom:"1px solid #F0E8D8" }}>
            <span style={{ fontSize:22, flexShrink:0 }}>{g.icon}</span>
            <div>
              <div style={{ fontSize:14, fontWeight:600, color:"#2C1E0E", fontFamily:"Inter,sans-serif", marginBottom:3 }}>{g.title}</div>
              <div style={{ fontSize:13, color:"#A89070", fontFamily:"'Lora',Georgia,serif", lineHeight:1.6 }}>{g.desc}</div>
            </div>
          </div>
        ))}
        <div style={{ marginTop:20, padding:"14px", background:"#FEF3C7", borderRadius:8, border:"1px solid #FCD34D", fontSize:13, color:"#92400E", fontFamily:"Inter,sans-serif", lineHeight:1.65 }}>
          Violations may result in content removal or account suspension. By continuing you agree to follow these guidelines.
        </div>
        <button onClick={onAccept} style={{ width:"100%", marginTop:16, padding:"13px", borderRadius:10, background:"#2C1E0E", color:"#FFFCF4", border:"none", cursor:"pointer", fontSize:15, fontFamily:"'Playfair Display',Georgia,serif", fontWeight:600 }}>
          I Agree — Enter My Testimony
        </button>
      </div>
    </div>
  );
}


// ── Auth screens ──────────────────────────────────────────────────────────────
const DEMO_USERS = [
  {id:"u1", name:"Thomas Ellery",   email:"thomas@example.com",  password:"password", initials:"TE", color:"#b45309", bio:"Sharing what God did in the operating room.", joined:"March 2024", posts:3},
  {id:"u2", name:"Marcus Webb",     email:"marcus@example.com",  password:"password", initials:"MW", color:"#0f766e", bio:"Redeemed. Walking free.", joined:"January 2024", posts:5},
];

function AuthPage({onAuth, D, onShowOnboarding}) {
  const [mode,       setMode]     = useState("login");
  const [name,       setName]     = useState("");
  const [email,      setEmail]    = useState("");
  const [password,   setPassword] = useState("");
  const [confirm,    setConfirm]  = useState("");
  const [error,      setError]    = useState("");
  const [loading,    setLoading]  = useState(false);

  const [showPw,     setShowPw]   = useState(false);
  const [agreedTos,  setAgreedTos]= useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [lockTime, setLockTime] = useState(0);
  async function handleForgotPassword(){
    if(!email.trim()){ setError("Please enter your email address first."); return; }
    setLoading(true);
    const {error} = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://mytestimonyapp.com"
    });
    setLoading(false);
    if(error){ setError(error.message); }
    else { setResetSent(true); }
  }
  const pwStr = password ? passwordStrength(password) : null;

  // Countdown for lockout
  useEffect(()=>{
    if (lockTime <= 0) return;
    const t = setTimeout(()=>setLockTime(s=>Math.max(0,s-1)),1000);
    return ()=>clearTimeout(t);
  },[lockTime]);

  const inputStyle = {
    width:"100%", padding:"12px 16px", borderRadius:10,
    border:`1.5px solid ${D.BDR}`, background:D.BG, color:D.TXT,
    fontSize:15, fontFamily:"'Lora',Georgia,serif", outline:"none",
    marginBottom:14, lineHeight:1.5, boxSizing:"border-box",
    transition:"border-color .2s"
  };
  const labelStyle = {
    fontSize:12, fontWeight:600, color:D.TXT3,
    fontFamily:"Inter,sans-serif", letterSpacing:".05em",
    textTransform:"uppercase", marginBottom:6, display:"block"
  };

  async function handleSubmit() {
    setError("");
    if (isLockedOut()) {
      const secs = Math.ceil((loginAttempts.lockedUntil - Date.now())/1000);
      setLockTime(secs);
      setError("Too many failed attempts. Please wait " + secs + " seconds.");
      return;
    }
    setLoading(true);
    try {
      if (mode === "login") {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) {
          recordFailedLogin();
          if (isLockedOut()) {
            setError("Too many failed attempts. Please wait 30 seconds.");
            setLockTime(30);
          } else {
            setError("Incorrect email or password. Please try again.");
          }
        } else {
          loginAttempts.count = 0;
          const { data: profile } = await supabase.from("profiles").select("*").eq("id", data.user.id).single();
          onAuth({ ...data.user, ...(profile||{}), id: data.user.id, name: profile?.name || email.split("@")[0] });
        }
      } else {
        const cleanName = sanitize(name);
        if (!cleanName)                               { setError("Please enter your name."); setLoading(false); return; }
        if (!email.includes("@"))                     { setError("Please enter a valid email."); setLoading(false); return; }
        if (password.length < 8)                      { setError("Password must be at least 8 characters."); setLoading(false); return; }
        if (passwordStrength(password).label==="Weak"){ setError("Please choose a stronger password."); setLoading(false); return; }
        if (password !== confirm)                     { setError("Passwords do not match."); setLoading(false); return; }
        if (!agreedTos)                               { setError("Please agree to the community guidelines."); setLoading(false); return; }
        if (containsBadWords(cleanName))              { setError("Please use an appropriate display name."); setLoading(false); return; }
        const { data, error } = await supabase.auth.signUp({
          email, password,
          options: { data: { name: cleanName } }
        });
        if (error) {
          setError(error.message);
        } else {
          await new Promise(r => setTimeout(r, 1000));
          const { data: profile } = await supabase.from("profiles").select("*").eq("id", data.user.id).single();
          onAuth({ ...data.user, ...(profile||{}), id: data.user.id, name: cleanName, showGuidelines: true });
        }
      }
    } catch(e) {
      setError("Something went wrong. Please try again.");
    }
    setLoading(false);
  }

  return (
    <div style={{minHeight:"100vh", background:D.BG, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"20px"}}>
      {/* Logo */}
      <div style={{marginBottom:28, display:"flex", flexDirection:"column", alignItems:"center", gap:10}}>
        <Logo size={64}/>
        <div style={{textAlign:"center"}}>
          <div style={{fontFamily:"'Playfair Display',Georgia,serif", fontSize:22, fontWeight:700, color:D.TXT, lineHeight:1}}>My Testimony</div>
          <div style={{fontSize:11, color:D.TXT3, fontFamily:"Inter,sans-serif", letterSpacing:".08em", textTransform:"uppercase", marginTop:4}}>Give Glory Through Your Story</div>
        </div>
      </div>

      {/* Card */}
      <div style={{width:"100%", maxWidth:420, background:D.CARD, borderRadius:16, border:`1px solid ${D.BDR}`, padding:"32px 32px 28px", boxShadow:"0 4px 24px rgba(100,80,40,.1)"}}>
        {/* Tabs */}
        <div style={{display:"flex", background:D.BG, borderRadius:10, padding:3, marginBottom:28, border:`1px solid ${D.BDR}`}}>
          {["login","signup"].map(m=>(
            <button key={m} onClick={()=>{setMode(m);setError("");}} style={{flex:1, padding:"9px", borderRadius:8, border:"none", cursor:"pointer", fontFamily:"Inter,sans-serif", fontWeight:600, fontSize:13, background:mode===m?D.CARD:"transparent", color:mode===m?D.TXT:D.TXT3, boxShadow:mode===m?"0 1px 4px rgba(0,0,0,.08)":"none", transition:"all .15s"}}>
              {m==="login" ? "Sign In" : "Create Account"}
            </button>
          ))}
        </div>

        <div style={{display:"flex", flexDirection:"column"}}>
          {mode==="signup" && (
            <div>
              <label style={labelStyle}>Your Name</label>
              <input value={name} onChange={e=>setName(e.target.value)} placeholder="Full name" style={inputStyle}
                onFocus={e=>e.target.style.borderColor="#b45309"} onBlur={e=>e.target.style.borderColor=D.BDR}/>
            </div>
          )}

          <div>
            <label style={labelStyle}>Email Address</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle}
              onFocus={e=>e.target.style.borderColor="#b45309"} onBlur={e=>e.target.style.borderColor=D.BDR}/>
          </div>

          <div>
            <label style={labelStyle}>Password</label>
            <div style={{position:"relative"}}>
              <input type={showPw?"text":"password"} value={password} onChange={e=>setPassword(e.target.value)} placeholder={mode==="signup"?"At least 8 characters":"••••••••"} style={{...inputStyle,paddingRight:44,marginBottom:0}}
                onFocus={e=>e.target.style.borderColor="#b45309"} onBlur={e=>e.target.style.borderColor=D.BDR}/>
              <button type="button" onClick={()=>setShowPw(v=>!v)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:D.TXT3,padding:0}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{showPw?<><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>:<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>}</svg>
              </button>
            </div>
            {mode==="login"&&(
              <div style={{textAlign:"right",marginTop:6,marginBottom:8}}>
                <button onClick={handleForgotPassword} style={{background:"none",border:"none",cursor:"pointer",color:"#b45309",fontSize:12,fontFamily:"Inter,sans-serif",textDecoration:"underline",padding:0}}>
                  Forgot password?
                </button>
              </div>
            )}
            {resetSent&&(
              <div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8,padding:"10px 14px",marginBottom:10,fontSize:13,color:"#166534",fontFamily:"Inter,sans-serif"}}>
                ✅ Password reset email sent! Check your inbox.
              </div>
            )}
            {mode==="signup" && password && pwStr && (
              <div style={{marginTop:8,marginBottom:14}}>
                <div style={{height:4,background:D.BDR,borderRadius:4,overflow:"hidden"}}>
                  <div style={{height:"100%",width:pwStr.width,background:pwStr.color,borderRadius:4,transition:"all .3s"}}/>
                </div>
                <span style={{fontSize:11,color:pwStr.color,fontFamily:"Inter,sans-serif",marginTop:4,display:"block"}}>{pwStr.label} password</span>
              </div>
            )}
            {mode!=="signup" && <div style={{marginBottom:14}}/>}
          </div>

          {mode==="signup" && (
            <div>
              <label style={labelStyle}>Confirm Password</label>
              <input type={showPw?"text":"password"} value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="Re-enter password" style={{...inputStyle,marginBottom:14}}
                onFocus={e=>e.target.style.borderColor="#b45309"} onBlur={e=>e.target.style.borderColor=D.BDR}/>
              <label style={{display:"flex",alignItems:"flex-start",gap:10,cursor:"pointer",marginBottom:0}}>
                <input type="checkbox" checked={agreedTos} onChange={e=>setAgreedTos(e.target.checked)} style={{marginTop:2,accentColor:"#b45309",flexShrink:0}}/>
                <span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif",lineHeight:1.6}}>I agree to the <span style={{color:"#b45309",textDecoration:"underline",cursor:"pointer"}}>Community Guidelines</span> and confirm this is my genuine faith testimony.</span>
              </label>
            </div>
          )}

          {error && (
            <div style={{background:"#FFF1F2", border:"1px solid #FECACA", borderRadius:8, padding:"10px 14px", marginTop:14, fontSize:13, color:"#991B1B", fontFamily:"Inter,sans-serif"}}>
              {error}
            </div>
          )}

          <button onClick={handleSubmit} disabled={loading} style={{marginTop:20, padding:"13px", borderRadius:10, background:loading?"#C8B090":"#2C1E0E", color:"#FFFCF4", border:"none", cursor:loading?"default":"pointer", fontSize:15, fontFamily:"'Playfair Display',Georgia,serif", fontWeight:600, letterSpacing:".02em", transition:"background .2s"}}>
            {loading ? "Please wait..." : mode==="login" ? "Sign In" : "Create My Account"}
          </button>

          
        </div>
      </div>

      {/* Footer note */}
      <p style={{marginTop:20, fontSize:12, color:D.TXT3, fontFamily:"Inter,sans-serif", textAlign:"center", maxWidth:340, lineHeight:1.6}}>
        A safe space for believers to share what God has done. Your testimony belongs to someone who hasn't read it yet.
      </p>
      <button onClick={onShowOnboarding} style={{marginTop:12,background:"none",border:"none",cursor:"pointer",color:"#b45309",fontSize:13,fontFamily:"Inter,sans-serif",textDecoration:"underline"}}>
        Learn more about My Testimony
      </button>
    </div>
  );
}

function ProfilePage({user, setUser, posts, onBack, D, setSelected, setView, setShowProfile, loadPostsFromDB, streak, setSelectedDraft}) {
  const [editing, setEditing] = useState(false);
  const [bio,     setBio]     = useState(user.bio || "");
  const [name,    setName]    = useState(user.name);
  const [profileTab, setProfileTab] = useState("stories");
  const [drafts, setDrafts] = useState([]);

  useEffect(()=>{
    if(!user?.id) return;
    supabase.from("drafts").select("*").eq("user_id",user.id).order("updated_at",{ascending:false})
      .then(({data})=>{ if(data) setDrafts(data); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const [followerCount,  setFollowerCount]  = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [followersList,  setFollowersList]  = useState([]);
  const [followingList,  setFollowingList]  = useState([]);

  useEffect(()=>{
    if(!user?.id) return;
    // Load followers
    supabase.from("follows").select("follower_id, profiles!follows_follower_id_fkey(id,name,initials,color,joined)")
      .eq("following_id",user.id)
      .then(({data})=>{
        if(data){
          setFollowerCount(data.length);
          setFollowersList(data.map(f=>f.profiles).filter(Boolean));
        }
      });
    // Load following
    supabase.from("follows").select("following_id, profiles!follows_following_id_fkey(id,name,initials,color,joined)")
      .eq("follower_id",user.id)
      .then(({data})=>{
        if(data){
          setFollowingCount(data.length);
          setFollowingList(data.map(f=>f.profiles).filter(Boolean));
        }
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const [likedIds,   setLikedIds]   = useState([]);
  const [savedIds,   setSavedIds]   = useState([]);

  const myPosts    = posts.filter(p => p.user_id === user.id || p.user_id === user.sub);
  const likedPosts = posts.filter(p => likedIds.includes(p.id));
  const savedPosts = posts.filter(p => savedIds.includes(p.id));

  useEffect(()=>{
    if(!user?.id) return;
    supabase.from("likes").select("post_id").eq("user_id",user.id)
      .then(({data})=>{ if(data) setLikedIds(data.map(l=>l.post_id)); });
    supabase.from("bookmarks").select("post_id").eq("user_id",user.id)
      .then(({data})=>{ if(data) setSavedIds(data.map(b=>b.post_id)); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  async function saveProfile() {
    const newName = name.trim()||user.name;
    const newInitials = newName.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
    await supabase.from("profiles").update({
      name:     newName,
      bio:      bio,
      initials: newInitials
    }).eq("id", user.id);
    setUser(u => ({...u, name: newName, bio, initials: newInitials}));
    setEditing(false);
  }

  return (
    <div style={{maxWidth:720, margin:"0 auto", padding:"0 20px 64px", background:D.BG}}>
      <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:6,color:D.TXT3,fontSize:13,fontFamily:"Inter,sans-serif",padding:"22px 0"}}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back to stories
      </button>

      {/* Profile header */}
      <div style={{background:D.CARD, borderRadius:16, border:`1px solid ${D.BDR}`, padding:"32px", marginBottom:24}}>
        <div style={{display:"flex", alignItems:"flex-start", gap:20, flexWrap:"wrap"}}>
          {/* Big avatar */}
          <div style={{position:"relative",flexShrink:0}}>
            {user.avatar_url
              ? <img src={user.avatar_url} alt={user.name} style={{width:72,height:72,borderRadius:"50%",objectFit:"cover",border:`2.5px solid ${user.color}`}}/>
              : <div style={{width:72,height:72,borderRadius:"50%",background:user.color+"22",border:`2.5px solid ${user.color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,fontWeight:700,color:user.color,fontFamily:"'Playfair Display',serif"}}>{user.initials}</div>
            }
            {editing&&(
              <label style={{position:"absolute",bottom:0,right:0,width:24,height:24,borderRadius:"50%",background:"#2C1E0E",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",border:"2px solid white"}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                <input type="file" accept="image/*" style={{display:"none"}} onChange={async(e)=>{
                  const file = e.target.files[0];
                  if(!file) return;
                  const ext = file.name.split(".").pop();
                  const path = `${user.id}/avatar.${ext}`;
                  const {error} = await supabase.storage.from("avatars").upload(path, file, {upsert:true});
                  if(!error){
                    const {data} = supabase.storage.from("avatars").getPublicUrl(path);
                    await supabase.from("profiles").update({avatar_url:data.publicUrl}).eq("id",user.id);
                    setUser(u=>({...u,avatar_url:data.publicUrl}));
                  }
                }}/>
              </label>
            )}
          </div>
          <div style={{flex:1, minWidth:200}}>
            {editing ? (
              <input value={name} onChange={e=>setName(e.target.value)} style={{fontSize:22, fontFamily:"'Playfair Display',Georgia,serif", fontWeight:700, color:D.TXT, border:"none", borderBottom:`2px solid ${D.BDR}`, outline:"none", background:"transparent", width:"100%", marginBottom:8}}/>
            ) : (
              <h2 style={{fontFamily:"'Playfair Display',Georgia,serif", fontSize:24, fontWeight:700, color:D.TXT, marginBottom:4}}>{user.name}</h2>
            )}
            <p style={{fontSize:12, color:D.TXT3, fontFamily:"Inter,sans-serif", marginBottom:12}}>{user.email} · Member since {user.joined}</p>
            {editing ? (
              <textarea value={bio} onChange={e=>setBio(e.target.value)} placeholder="Tell the community about yourself..." style={{width:"100%", padding:"10px 12px", borderRadius:8, border:`1px solid ${D.BDR}`, background:D.BG, color:D.TXT, fontSize:14, fontFamily:"'Lora',Georgia,serif", resize:"none", minHeight:70, outline:"none", lineHeight:1.6}}/>
            ) : (
              <p style={{fontSize:14, color:D.TXT2, fontFamily:"'Lora',Georgia,serif", lineHeight:1.65}}>{user.bio || "No bio yet. Click Edit Profile to add one."}</p>
            )}
          </div>
          <div>
            {editing ? (
              <div style={{display:"flex", gap:8}}>
                <button onClick={()=>setEditing(false)} style={{padding:"8px 14px", borderRadius:20, border:`1px solid ${D.BDR}`, background:"transparent", color:D.TXT3, cursor:"pointer", fontSize:12, fontFamily:"Inter,sans-serif"}}>Cancel</button>
                <button onClick={saveProfile} style={{padding:"8px 16px", borderRadius:20, border:"none", background:"#2C1E0E", color:"#FFFCF4", cursor:"pointer", fontSize:12, fontFamily:"Inter,sans-serif", fontWeight:600}}>Save</button>
              </div>
            ) : (
              <button onClick={()=>setEditing(true)} style={{padding:"8px 16px", borderRadius:20, border:`1px solid ${D.BDR}`, background:"transparent", color:D.TXT3, cursor:"pointer", fontSize:12, fontFamily:"Inter,sans-serif", display:"flex", alignItems:"center", gap:5}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Edit Profile
              </button>
            )}
          </div>
        </div>

        {/* Streak */}
        {streak.current > 0 && (
          <div style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"12px 16px",marginBottom:20,display:"flex",alignItems:"center",gap:12}}>
            <span style={{fontSize:28}}>🔥</span>
            <div>
              <div style={{fontSize:15,fontWeight:700,color:D.TXT,fontFamily:"'Playfair Display',serif"}}>{streak.current} day{streak.current!==1?"s":""} reading streak!</div>
              <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>Longest streak: {streak.longest} day{streak.longest!==1?"s":""}</div>
            </div>
          </div>
        )}
        {/* Stats */}
        <div style={{display:"flex", gap:16, marginTop:24, paddingTop:20, borderTop:`1px solid ${D.BDR}`, flexWrap:"wrap", justifyContent:"center"}}>
          {[["Stories shared", myPosts.length], ["Followers", followerCount], ["Following", followingCount], ["Likes received", myPosts.reduce((a,p)=>a+p.likes,0)], ["Comments received", myPosts.reduce((a,p)=>a+p.comments,0)]].map(([label,val])=>(
            <div key={label} style={{textAlign:"center"}}>
              <div style={{fontSize:22, fontWeight:700, color:D.TXT, fontFamily:"'Playfair Display',serif"}}>{val}</div>
              <div style={{fontSize:11, color:D.TXT3, fontFamily:"Inter,sans-serif", marginTop:2}}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:0,marginBottom:24,borderBottom:`1px solid ${D.BDR}`,overflowX:"auto",scrollbarWidth:"none"}}>
        {[["stories","Your Stories"],["drafts","Drafts 📝"],["liked","Liked ❤️"],["saved","Saved 🔖"],["followers","Followers"],["following","Following"]].map(([id,label])=>(
          <button key={id} onClick={()=>setProfileTab(id)} style={{padding:"10px 14px",whiteSpace:"nowrap",background:"none",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:profileTab===id?700:400,color:profileTab===id?D.TXT:D.TXT3,borderBottom:profileTab===id?"2px solid #b45309":"2px solid transparent",marginBottom:-1,flexShrink:0}}>
            {label}
          </button>
        ))}
      </div>

      {/* User's posts */}
      {profileTab==="stories"&&<>
      <h3 style={{fontFamily:"'Playfair Display',Georgia,serif", fontSize:20, fontWeight:700, color:D.TXT, marginBottom:16}}>
        {myPosts.length > 0 ? "Your Stories" : "You haven't shared a story yet"}
      </h3>
      {myPosts.length === 0 && (
        <p style={{fontSize:14, color:D.TXT3, fontFamily:"'Lora',Georgia,serif", lineHeight:1.7}}>
          Your testimony belongs to someone who hasn't read it yet. When you're ready, click "Share Your Story."
        </p>
      )}
      <div style={{display:"flex", flexDirection:"column", gap:14}}>
        {myPosts.map(post=>(
          <div key={post.id} onClick={()=>{setShowProfile(false);setSelected(post);setView("post");}} style={{background:D.CARD, border:`1px solid ${D.BDR}`, borderRadius:10, padding:"16px 20px", display:"flex", alignItems:"center", gap:16, cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.opacity="0.8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
            <div style={{flex:1}}>
              <div style={{fontFamily:"'Playfair Display',Georgia,serif", fontSize:16, fontWeight:600, color:D.TXT, marginBottom:4}}>{post.title}</div>
              <div style={{fontSize:12, color:D.TXT3, fontFamily:"Inter,sans-serif"}}>{post.date} · {post.category}</div>
            </div>
            <div style={{display:"flex", gap:10, alignItems:"center", flexShrink:0}}>
  <span style={{fontSize:12, color:D.TXT3, fontFamily:"Inter,sans-serif"}}>❤ {post.likes}</span>
  <span style={{fontSize:12, color:D.TXT3, fontFamily:"Inter,sans-serif"}}>💬 {post.comments}</span>
  <button onClick={async(e)=>{
    e.stopPropagation();
    if(!window.confirm("Delete this story? This cannot be undone.")) return;
    const {error} = await supabase.from("posts").delete().eq("id",post.id).eq("user_id",user.id);
    if(!error) await loadPostsFromDB();
    else alert("Could not delete: "+error.message);
  }} style={{background:"none",border:"1px solid #FECACA",borderRadius:20,cursor:"pointer",color:"#dc2626",padding:"4px 10px",fontSize:11,fontFamily:"Inter,sans-serif",display:"flex",alignItems:"center",gap:4}}>
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
    Delete
  </button>
</div>
          </div>
        ))}
      </div>
      </>}
{profileTab==="drafts"&&<>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:16}}>Your Drafts</h3>
        {drafts.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>No drafts yet. Start writing and click Save Draft to save your progress.</p>}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {drafts.map(draft=>(
            <div key={draft.id} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"16px 20px",display:"flex",alignItems:"center",gap:16}}>
              <div style={{flex:1}}>
                <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:600,color:D.TXT,marginBottom:4}}>{draft.title||"Untitled Draft"}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{draft.category} · Last saved {new Date(draft.updated_at).toLocaleDateString("en-US",{month:"long",day:"numeric"})}</div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>{setSelectedDraft(draft);setShowProfile(false);setView("write");}} style={{padding:"6px 14px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Continue</button>
                <button onClick={async()=>{
                  if(!window.confirm("Delete this draft?")) return;
                  await supabase.from("drafts").delete().eq("id",draft.id);
                  setDrafts(ds=>ds.filter(d=>d.id!==draft.id));
                }} style={{padding:"6px 14px",borderRadius:20,background:"none",border:"1px solid #FECACA",color:"#dc2626",cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </>}

      {profileTab==="liked"&&<></>
  
      }

      {profileTab==="followers"&&<>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:16}}>People Following You</h3>
        {followersList.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>No followers yet. Share your testimony and people will follow!</p>}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {followersList.map(f=>(
            <div key={f.id} style={{display:"flex",alignItems:"center",gap:12,background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"14px 16px"}}>
              <Avi a={{name:f.name,initials:f.initials,color:f.color}} size={38}/>
              <div>
                <div style={{fontSize:14,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{f.name}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>Member since {f.joined}</div>
              </div>
            </div>
          ))}
        </div>
      </>}

      {profileTab==="following"&&<>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:16}}>People You Follow</h3>
        {followingList.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>You are not following anyone yet. Open a story and click Follow!</p>}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {followingList.map(f=>(
            <div key={f.id} style={{display:"flex",alignItems:"center",gap:12,background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"14px 16px"}}>
              <Avi a={{name:f.name,initials:f.initials,color:f.color}} size={38}/>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{f.name}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>Member since {f.joined}</div>
              </div>
              <button onClick={async()=>{
                await supabase.from("follows").delete().eq("follower_id",user.id).eq("following_id",f.id);
                setFollowingList(fl=>fl.filter(x=>x.id!==f.id));
                setFollowingCount(c=>c-1);
              }} style={{padding:"6px 12px",borderRadius:20,border:"1px solid #FECACA",background:"transparent",color:"#dc2626",cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Unfollow</button>
            </div>
          ))}
        </div>
      </>}

      {profileTab==="liked"&&<>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:16}}>Posts You Liked</h3>
        {likedPosts.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7}}>You haven't liked any posts yet.</p>}
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {likedPosts.map(post=>(
            <div key={post.id} onClick={()=>{setShowProfile(false);setSelected(post);setView("post");}} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"16px 20px",display:"flex",alignItems:"center",gap:16,cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.opacity="0.8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
              <div style={{flex:1}}>
                <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:600,color:D.TXT,marginBottom:4}}>{post.title}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.category}</div>
              </div>
              <span style={{fontSize:16}}>❤️</span>
            </div>
          ))}
        </div>
      </>}

      {profileTab==="saved"&&<>
        <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:16}}>Saved Posts</h3>
        {savedPosts.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7}}>You haven't saved any posts yet.</p>}
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {savedPosts.map(post=>(
            <div key={post.id} onClick={()=>{setShowProfile(false);setSelected(post);setView("post");}} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"16px 20px",display:"flex",alignItems:"center",gap:16,cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.opacity="0.8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
              <div style={{flex:1}}>
                <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:600,color:D.TXT,marginBottom:4}}>{post.title}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.category}</div>
              </div>
              <span style={{fontSize:16}}>🔖</span>
            </div>
          ))}
        </div>
      </>}
    </div>
  );
}



// ── Help Page ─────────────────────────────────────────────────────────────────
function UserProfileModal({profileUser, currentUser, D, onClose, posts}) {
  const [userStreak, setUserStreak] = useState(0);
  const [following, setFollowing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    
    if(!profileUser?.id) return;
    supabase.from("streaks").select("current").eq("user_id",profileUser.id).single()
      .then(({data,error})=>{  if(data) setUserStreak(data.current); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const userPosts = posts.filter(p => p.user_id === profileUser.id);

  useEffect(()=>{
    if(!currentUser?.id||!profileUser?.id) return;
    supabase.from("follows").select("*").eq("follower_id",currentUser.id).eq("following_id",profileUser.id)
      .then(({data})=>{ if(data&&data.length>0) setFollowing(true); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  async function toggleFollow(){
    if(loading) return;
    setLoading(true);
    if(following){
      await supabase.from("follows").delete().eq("follower_id",currentUser.id).eq("following_id",profileUser.id);
      setFollowing(false);
    } else {
      await supabase.from("follows").insert({follower_id:currentUser.id,following_id:profileUser.id});
      setFollowing(true);
    }
    setLoading(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#FFFCF4",borderRadius:16,border:"1px solid #E8DBBF",padding:"28px",maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,0.25)",maxHeight:"80vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,color:D.TXT,margin:0}}>Member Profile</h3>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:D.TXT3}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:20}}>
          <Avi a={{name:profileUser.name,initials:profileUser.initials,color:profileUser.color,avatar_url:profileUser.avatar_url}} size={56}/>
          <div style={{flex:1}}>
            <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:4}}>{profileUser.name}</div>
            <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{userPosts.length} {userPosts.length===1?"story":"stories"} shared</div>
              {userStreak>0&&<div style={{fontSize:12,color:"#b45309",fontFamily:"Inter,sans-serif",marginTop:2}}>🔥 {userStreak} day streak</div>}
          </div>
          {currentUser?.id!==profileUser.id&&(
            <button onClick={toggleFollow} disabled={loading} style={{padding:"8px 16px",borderRadius:20,border:`1.5px solid ${following?"#b45309":D.BDR}`,background:following?"#FEF3C7":"transparent",color:following?"#92400E":D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:following?600:400,opacity:loading?0.6:1}}>
              {following?"Following ✓":"Follow"}
            </button>
          )}
        </div>
        {profileUser.bio&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7,marginBottom:16,padding:"12px 14px",background:D.BG,borderRadius:8}}>{profileUser.bio}</p>}
        <h4 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:700,color:D.TXT,marginBottom:12}}>Their Stories</h4>
        {userPosts.length===0&&<p style={{fontSize:13,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>No stories shared yet.</p>}
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {userPosts.slice(0,5).map(post=>(
            <div key={post.id} onClick={onClose} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:8,padding:"12px 14px",cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.opacity="0.8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
              <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:14,fontWeight:600,color:D.TXT,marginBottom:2}}>{post.title}</div>
              <div style={{fontSize:11,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.category}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function GroupsPage({user, D, posts, setSelected, setView, setShowGroups}) {
  const [tab,       setTab]       = useState("my");
  const [myGroups,  setMyGroups]  = useState([]);
  const [creating,  setCreating]  = useState(false);
  const [joining,   setJoining]   = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupDesc, setGroupDesc] = useState("");
  const [groupChurch,setGroupChurch]=useState("");
  const [joinCode,  setJoinCode]  = useState("");
  const [selected,  setSelectedG] = useState(null);
  const [groupPosts,setGroupPosts]= useState([]);
  const [groupMessages,setGroupMessages] = useState([]);
  const [groupTab,setGroupTab]           = useState("posts");
  const [newMessage,setNewMessage]       = useState("");

  useEffect(()=>{
    if(!user?.id) return;
    supabase.from("group_members")
      .select("group_id, groups(id,name,description,church,invite_code,created_by)")
      .eq("user_id",user.id)
      .then(({data})=>{ if(data) setMyGroups(data.map(m=>m.groups).filter(Boolean)); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  async function createGroup(){
    if(!groupName.trim()) return;
    const {data,error} = await supabase.from("groups").insert({
      name:groupName.trim(), description:groupDesc.trim(),
      church:groupChurch.trim(), created_by:user.id
    }).select().single();
    if(!error&&data){
      await supabase.from("group_members").insert({group_id:data.id,user_id:user.id,role:"admin"});
      setMyGroups(g=>[...g,data]);
      setCreating(false); setGroupName(""); setGroupDesc(""); setGroupChurch("");
    }
  }

  async function joinGroup(){
    if(!joinCode.trim()) return;
    const {data:group} = await supabase.from("groups").select("*").eq("invite_code",joinCode.trim().toLowerCase()).single();
    if(!group){alert("That invite code doesn't match any group. Please double-check the code and try again.");return;}
    const {error} = await supabase.from("group_members").insert({group_id:group.id,user_id:user.id,role:"member"});
    if(!error){ setMyGroups(g=>[...g,group]); setJoining(false); setJoinCode(""); }
    else { alert("Looks like you're already a member of this group!"); }
  }

async function openGroup(group){
    setSelectedG(group);
    // Load group stories
    const {data, error} = await supabase.from("group_posts")
      .select("post_id, posts(*, profiles!posts_user_id_fkey(name,initials,color))")
      .eq("group_id",group.id);
    console.log("GROUP POSTS:", data, "ERROR:", error);
    if(data) setGroupPosts(data.map(gp=>({
      ...gp.posts,
      author:{name:gp.posts?.profiles?.name||"Anonymous",initials:gp.posts?.profiles?.initials||"A",color:gp.posts?.profiles?.color||"#b45309"}
    })).filter(Boolean));
    // Load group messages
    const {data:msgs} = await supabase.from("group_messages")
      .select("*")
      .eq("group_id",group.id)
      .order("created_at",{ascending:true});
    if(msgs) setGroupMessages(msgs);
  }

  if(selected){
    return(
      <div style={{maxWidth:760,margin:"0 auto",padding:"0 20px 64px",background:D.BG}}>
        <button onClick={()=>{setSelectedG(null);setGroupMessages([]);setGroupTab("posts");}} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:6,color:D.TXT3,fontSize:13,fontFamily:"Inter,sans-serif",padding:"22px 0"}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          Back to Groups
        </button>

        {/* Group Header */}
        <div style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:16,padding:"24px",marginBottom:20}}>
          <h2 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:24,fontWeight:700,color:D.TXT,marginBottom:6}}>{selected.name}</h2>
          {selected.church&&<p style={{fontSize:13,color:"#b45309",fontFamily:"Inter,sans-serif",marginBottom:8}}>⛪ {selected.church}</p>}
          {selected.description&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.65,marginBottom:12}}>{selected.description}</p>}
          <div style={{background:D.BG,borderRadius:8,padding:"10px 14px",display:"inline-flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>Invite code:</span>
            <span style={{fontSize:14,fontWeight:700,color:D.TXT,fontFamily:"Inter,sans-serif",letterSpacing:".08em"}}>{selected.invite_code}</span>
            <button onClick={()=>{navigator.clipboard.writeText(selected.invite_code);alert("Invite code copied!");}} style={{background:"none",border:"none",cursor:"pointer",color:"#b45309",fontSize:12,fontFamily:"Inter,sans-serif"}}>Copy</button>
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:`1px solid ${D.BDR}`}}>
          {[["posts","📖 Stories"],["chat","💬 Discussion"]].map(([id,label])=>(
            <button key={id} onClick={()=>setGroupTab(id)} style={{padding:"10px 20px",background:"none",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:groupTab===id?700:400,color:groupTab===id?D.TXT:D.TXT3,borderBottom:groupTab===id?"2px solid #b45309":"2px solid transparent",marginBottom:-1}}>
              {label}
            </button>
          ))}
        </div>

        {/* Stories Tab */}
        {groupTab==="posts"&&<>
          <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:18,fontWeight:700,color:D.TXT,marginBottom:16}}>Group Stories ({groupPosts.length})</h3>
          {groupPosts.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>No stories shared in this group yet. Open any story and click "Share to Group"!</p>}
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {groupPosts.map(post=>(
              <div key={post.id} onClick={()=>{setShowGroups(false);setSelected(post);setView("post");}} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"16px 20px",cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.opacity="0.8"} onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:600,color:D.TXT,marginBottom:4}}>{post.title}</div>
                <div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{post.author.name} · {post.category}</div>
              </div>
            ))}
          </div>
        </>}

        {/* Discussion Tab */}
        {groupTab==="chat"&&<>
          <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:20,maxHeight:500,overflowY:"auto"}}>
            {groupMessages.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",textAlign:"center",padding:"24px 0"}}>No messages yet. Start the conversation!</p>}
            {groupMessages.map(msg=>(
              <div key={msg.id} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                <Avi a={{name:msg.author_name,initials:msg.author_initials,color:msg.author_color}} size={32}/>
                <div style={{flex:1,background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:10,padding:"10px 14px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                    <span style={{fontSize:13,fontWeight:600,color:D.TXT,fontFamily:"Inter,sans-serif"}}>{msg.author_name}</span>
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <span style={{fontSize:10,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>{new Date(msg.created_at).toLocaleDateString("en-US",{month:"short",day:"numeric"})}</span>
                      {msg.user_id===user?.id&&(
                        <button onClick={async()=>{
                          await supabase.from("group_messages").delete().eq("id",msg.id);
                          setGroupMessages(ms=>ms.filter(m=>m.id!==msg.id));
                        }} style={{background:"none",border:"none",cursor:"pointer",color:"#dc2626",fontSize:10,fontFamily:"Inter,sans-serif",padding:0}}>Delete</button>
                      )}
                    </div>
                  </div>
                  <p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.65,margin:0}}>{msg.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:10,alignItems:"flex-end"}}>
            <Avi a={{name:user?.name||"You",initials:user?.initials||"Y",color:user?.color||"#d97706"}} size={32}/>
            <div style={{flex:1}}>
              <textarea value={newMessage} onChange={e=>setNewMessage(e.target.value)} placeholder="Share a thought, prayer request, or encouragement..." spellCheck={true} autoCorrect="on" style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:14,fontFamily:"'Lora',Georgia,serif",resize:"none",minHeight:70,outline:"none",lineHeight:1.6}}/>
              {newMessage.trim()&&(
                <button onClick={async()=>{
                  const clean = sanitize(newMessage);
                  if(containsBadWords(clean)){alert("Message violates community guidelines.");return;}
                  const {data:msg} = await supabase.from("group_messages").insert({
                    group_id:        selected.id,
                    user_id:         user?.id,
                    text:            clean,
                    author_name:     user?.name||"Anonymous",
                    author_initials: user?.initials||"A",
                    author_color:    user?.color||"#b45309"
                  }).select().single();
                  if(msg) setGroupMessages(ms=>[...ms,msg]);
                  setNewMessage("");
                }} style={{marginTop:8,padding:"9px 20px",background:"#2C1E0E",color:"#FFFCF4",border:"none",borderRadius:20,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>Send</button>
              )}
            </div>
          </div>
        </>}
      </div>
    );
  }

  return(
    <div style={{maxWidth:760,margin:"0 auto",padding:"0 20px 64px",background:D.BG}}>
      <button onClick={()=>setShowGroups(false)} style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:6,color:D.TXT3,fontSize:13,fontFamily:"Inter,sans-serif",padding:"22px 0"}}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back to stories
      </button>
      <div style={{textAlign:"center",marginBottom:32}}>
        <div style={{fontSize:40,marginBottom:10}}>⛪</div>
        <h1 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:28,fontWeight:700,color:D.TXT,marginBottom:8}}>Church Groups</h1>
        <p style={{fontSize:15,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7}}>Share testimonies privately within your church community.</p>
      </div>
      <div style={{display:"flex",gap:10,marginBottom:24,justifyContent:"center"}}>
        <button onClick={()=>setCreating(true)} style={{padding:"10px 20px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>+ Create Group</button>
        <button onClick={()=>setJoining(true)} style={{padding:"10px 20px",borderRadius:20,background:"transparent",color:D.TXT,border:`1px solid ${D.BDR}`,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Join with Code</button>
      </div>

      {creating&&(
        <div style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:12,padding:"24px",marginBottom:24}}>
          <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:18,fontWeight:700,color:D.TXT,marginBottom:16}}>Create a Church Group</h3>
          <input value={groupName} onChange={e=>setGroupName(e.target.value)} placeholder="Group name (e.g. Grace Church Testimonies)" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",marginBottom:10,outline:"none",boxSizing:"border-box"}}/>
          <input value={groupChurch} onChange={e=>setGroupChurch(e.target.value)} placeholder="Church name (optional)" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",marginBottom:10,outline:"none",boxSizing:"border-box"}}/>
          <textarea value={groupDesc} onChange={e=>setGroupDesc(e.target.value)} placeholder="Description (optional)" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"'Lora',Georgia,serif",marginBottom:14,outline:"none",resize:"none",minHeight:70,lineHeight:1.6,boxSizing:"border-box"}}/>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setCreating(false)} style={{padding:"9px 18px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Cancel</button>
            <button onClick={createGroup} style={{padding:"9px 18px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>Create Group</button>
          </div>
        </div>
      )}

      {joining&&(
        <div style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:12,padding:"24px",marginBottom:24}}>
          <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:18,fontWeight:700,color:D.TXT,marginBottom:16}}>Join a Group</h3>
          <input value={joinCode} onChange={e=>setJoinCode(e.target.value)} placeholder="Enter invite code" style={{width:"100%",padding:"10px 14px",borderRadius:8,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",marginBottom:14,outline:"none",boxSizing:"border-box"}}/>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setJoining(false)} style={{padding:"9px 18px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Cancel</button>
            <button onClick={joinGroup} style={{padding:"9px 18px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>Join Group</button>
          </div>
        </div>
      )}

      <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:18,fontWeight:700,color:D.TXT,marginBottom:16}}>Your Groups ({myGroups.length})</h3>
      {myGroups.length===0&&<p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7}}>You are not in any groups yet. Create one or join with an invite code.</p>}
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {myGroups.map(g=>(
          <div key={g.id} onClick={()=>openGroup(g)} style={{background:D.CARD,border:`1px solid ${D.BDR}`,borderRadius:12,padding:"18px 20px",cursor:"pointer",transition:"transform .15s"}} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform=""}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:44,height:44,borderRadius:10,background:"#FEF3C7",border:"1px solid #FCD34D",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>⛪</div>
              <div>
                <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontWeight:700,color:D.TXT,marginBottom:2}}>{g.name}</div>
                {g.church&&<div style={{fontSize:12,color:"#b45309",fontFamily:"Inter,sans-serif"}}>{g.church}</div>}
                {g.description&&<div style={{fontSize:12,color:D.TXT3,fontFamily:"Inter,sans-serif",marginTop:2}}>{g.description}</div>}
              </div>
              <svg style={{marginLeft:"auto",flexShrink:0}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={D.TXT3} strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
function HelpPage({ onBack, D }) {
  const [open, setOpen] = useState(null);
  const [showSupport, setShowSupport] = useState(false);
  const [supportMsg, setSupportMsg] = useState("");
  const [supportSent, setSupportSent] = useState(false);

  const sections = [
    {
      title: "Getting Started",
      icon: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
      color: "#b45309",
      faqs: [
        { q: "How do I create an account?", a: "Tap 'Create Account' on the sign-in screen. Enter your name, email, and a password (at least 8 characters). Your account is created instantly." },
        { q: "Is My Testimony free to use?", a: "Yes, completely free. Read stories, share your testimony, like, comment, and join church groups — all at no cost." },
        { q: "Do I need an account to read stories?", a: "You need an account to access the app, but creating one takes less than a minute. This helps keep the community safe and authentic." },
        { q: "How do I sign out?", a: "Click your profile avatar in the top-right corner. This opens your profile, where you'll find the Sign Out button." },
        { q: "How do I reset my password?", a: "On the login screen, click 'Forgot password?' and enter your email. You'll receive a reset link in your inbox within a few minutes." },
      ]
    },
    {
      title: "Sharing Your Testimony",
      icon: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
      color: "#0f766e",
      faqs: [
        { q: "How do I share my story?", a: "Click the 'Share Your Story' button in the top-right of the navigation bar. You'll get a full writing editor where you can add a title, choose a category, write your testimony, and add images." },
        { q: "Is there a word limit?", a: "No. Write as much as God puts on your heart. There is no word limit on My Testimony." },
        { q: "Can I add photos to my story?", a: "Yes! In the writing editor, tap 'Add cover photo' to add a header image, or 'Insert image' to place a photo inside your story. You can also paste images directly from your clipboard." },
        { q: "What categories can I choose from?", a: "There are 50 categories including NDE, Healing, Jesus, Church, Prayer, Dreams, Salvation, Deliverance, Provision, Protection, Marriage, Family, Grief, Forgiveness, and many more." },
        { q: "Can I save a draft before publishing?", a: "Yes! Click 'Save draft' in the editor. Your draft is saved to your account and you can find it in the Drafts tab on your profile page." },
        { q: "Can I delete my story after publishing?", a: "Yes. Open your story and click the red 'Delete Story' button at the top. You can also delete from your profile page. This cannot be undone." },
        { q: "Can I post anonymously?", a: "Yes! Check the 'Post anonymously' box in the editor before publishing. Your name will be hidden and shown as Anonymous to all other users." },
      ]
    },
    {
      title: "Reading & Discovering Stories",
      icon: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
      color: "#1d4ed8",
      faqs: [
        { q: "How do I find stories on a specific topic?", a: "Use the category filter bar to browse all 50 categories. You can also use the search bar to search by author name, scripture reference, or keyword." },
        { q: "How do I like a story?", a: "Tap the heart icon on any story card or inside a full story. Your like is saved to your account and you can find all liked stories in the Liked tab on your profile." },
        { q: "How do I save a story to read later?", a: "Tap the bookmark icon on any story. Saved stories appear in the Saved tab on your profile page." },
        { q: "How do I leave a comment?", a: "Open a story and scroll to the bottom. Type your response in the comment box and tap 'Post Response.' You can also reply to other comments." },
        { q: "What is the Daily Testimony?", a: "Every day a different testimony is featured at the top of the feed — like a daily devotional. It changes automatically each day." },
        { q: "How do I change the text size?", a: "Open any story and look for the text size buttons (A A A A) near the top of the content. Tap to make text smaller or larger." },
      ]
    },
    {
      title: "Your Profile",
      icon: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
      color: "#7c3aed",
      faqs: [
        { q: "How do I update my name, bio, or photo?", a: "Click your profile avatar in the top-right to open your profile, then click 'Edit Profile.' You can update your display name, add a bio, and upload a profile photo." },
        { q: "Where can I see all my stories?", a: "Your profile has tabs for Your Stories, Drafts, Liked, Saved, Followers, and Following. Click your avatar in the top-right to access your profile." },
        { q: "Can other users see my profile?", a: "Yes! When someone clicks your name on a post they can see your profile including your bio, stories, and reading streak." },
        { q: "What is a reading streak?", a: "Your streak tracks how many days in a row you read testimonies. It shows on your profile with a 🔥 icon. Keep coming back daily to build your streak!" },
        { q: "How do I follow someone?", a: "Open any story and click the 'Follow' button next to the author's name. Their new stories will appear in a special section at the top of your feed." },
      ]
    },
    {
      title: "Language & Accessibility",
      icon: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 0 1 6.412 9m6.088 9h7M11 21 9.5 7",
      color: "#be185d",
      faqs: [
        { q: "What languages is the app available in?", a: "My Testimony is available in 10 languages: English, Spanish, French, Portuguese, German, Chinese, Korean, Hindi, Arabic, and Swahili. Tap the language button in the navigation bar to switch." },
        { q: "Does Arabic display correctly right-to-left?", a: "Yes. When you select Arabic, the entire app layout flips to right-to-left to match the natural reading direction." },
        { q: "Is there a dark mode?", a: "Yes. Tap the moon icon in the navigation bar to switch to night mode. Tap the sun icon to return to light mode." },
      ]
    },
    {
      title: "Church Groups",
      icon: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M23 21v-2a4 4 0 0 1-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
      color: "#0f766e",
      faqs: [
        { q: "How do I create a church group?", a: "Click 'Groups' in the navigation bar, then click 'Create Group.' Enter your group name, church name, and description. An invite code is automatically generated." },
        { q: "How do I invite people to my group?", a: "Open your group and you'll see your invite code. Share this code with your church members. They click 'Join with Code' and enter it to join instantly." },
        { q: "What can I do in a group?", a: "Groups have two tabs — Stories and Discussion. In Stories you can see testimonies shared to the group. In Discussion you can send messages and prayer requests to your church community." },
        { q: "How do I share a story to a group?", a: "Open any testimony and click 'Share to Group.' Select which group you want to share it to. Members of that group will be able to see it." },
      ]
    },
    {
      title: "Community & Safety",
      icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
      color: "#dc2626",
      faqs: [
        { q: "Is this a safe space for sharing?", a: "Yes. My Testimony is built specifically for believers to share in a respectful, faith-affirming environment. We do not tolerate harassment, hate speech, or content that contradicts the mission of glorifying God." },
        { q: "How do I report inappropriate content?", a: "Open any story and click the red 'Report' button. Select a reason and submit. Our team will review it within 24 hours." },
        { q: "Can anyone post anything?", a: "Posts should be genuine faith testimonies — real experiences of God's work in your life. This is not a general blog or social media platform. We ask all members to honor the sacred nature of this space." },
        { q: "Are children allowed to use the app?", a: "My Testimony is designed for users 13 and older. All content is family-friendly and faith-centered." },
      ]
    },
    {
      title: "Technical Help",
      icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
      color: "#475569",
      faqs: [
        { q: "Why can't I paste an image into my story?", a: "Image pasting works best in Chrome and Edge browsers. If it's not working, use the 'Insert image' button in the editor toolbar to upload an image from your device instead." },
        { q: "The app looks different on my phone. Is that normal?", a: "The app is designed to work on mobile browsers. For the best experience use Chrome or Safari on your phone." },
        { q: "My notifications aren't working. What do I do?", a: "Make sure your email address is correct in your account. Email notifications are sent when someone likes, comments on, or follows you." },
        { q: "How do I contact support?", a: "Scroll to the bottom of this Help Center and click 'Contact Support' to send us a message directly." },
      ]
    },
  ];

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "0 20px 64px", background: D.BG }}>
      <button onClick={onBack} style={{ background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:6, color:D.TXT3, fontSize:13, fontFamily:"Inter,sans-serif", padding:"22px 0" }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back to stories
      </button>

      {/* Header */}
      <div style={{ textAlign:"center", marginBottom:40 }}>
        <div style={{ width:56, height:56, borderRadius:"50%", background:"#FEF3C7", border:"2px solid #FCD34D", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        <h1 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:32, fontWeight:700, color:D.TXT, marginBottom:10 }}>Help Center</h1>
        <p style={{ fontSize:15, color:D.TXT3, fontFamily:"'Lora',Georgia,serif", lineHeight:1.7, maxWidth:460, margin:"0 auto" }}>
          Everything you need to know about sharing your testimony and using the app.
        </p>
      </div>

      {/* Sections */}
      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {sections.map((section, si) => (
          <div key={si} style={{ background:D.CARD, border:`1px solid ${D.BDR}`, borderRadius:12, overflow:"hidden" }}>
            {/* Section header */}
            <div style={{ padding:"20px 24px", display:"flex", alignItems:"center", gap:14 }}>
              <div style={{ width:38, height:38, borderRadius:10, background:`${section.color}18`, border:`1px solid ${section.color}44`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={section.color} strokeWidth="1.8">
                  {section.icon.split(" M").map((d,i)=><path key={i} d={i===0?d:"M"+d}/>)}
                </svg>
              </div>
              <h2 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:18, fontWeight:700, color:D.TXT, margin:0 }}>{section.title}</h2>
              <span style={{ marginLeft:"auto", fontSize:11, color:D.TXT3, fontFamily:"Inter,sans-serif" }}>{section.faqs.length} answers</span>
            </div>

            {/* FAQs */}
            <div style={{ borderTop:`1px solid ${D.BDR}` }}>
              {section.faqs.map((faq, fi) => {
                const key = `${si}-${fi}`;
                const isOpen = open === key;
                return (
                  <div key={fi} style={{ borderBottom: fi < section.faqs.length-1 ? `1px solid ${D.BDR}` : "none" }}>
                    <button
                      onClick={() => setOpen(isOpen ? null : key)}
                      style={{ width:"100%", padding:"16px 24px", background:"transparent", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between", gap:16, textAlign:"left" }}
                    >
                      <span style={{ fontSize:14, fontWeight:600, color:D.TXT, fontFamily:"Inter,sans-serif", lineHeight:1.4 }}>{faq.q}</span>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={D.TXT3} strokeWidth="2" style={{ flexShrink:0, transform:isOpen?"rotate(180deg)":"none", transition:"transform .2s" }}>
                        <path d="M6 9l6 6 6-6"/>
                      </svg>
                    </button>
                    {isOpen && (
                      <div style={{ padding:"0 24px 18px", paddingLeft:24 }}>
                        <p style={{ fontSize:14, color:D.TXT3, fontFamily:"'Lora',Georgia,serif", lineHeight:1.78, margin:0 }}>{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Contact */}
      <div style={{ marginTop:32, background:D.CARD, border:`1px solid ${D.BDR}`, borderRadius:12, padding:"28px 28px", textAlign:"center" }}>
        <div style={{ fontSize:28, marginBottom:10 }}>✉️</div>
        <h3 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:18, fontWeight:700, color:D.TXT, marginBottom:8 }}>Still need help?</h3>
        <p style={{ fontSize:14, color:D.TXT3, fontFamily:"'Lora',Georgia,serif", lineHeight:1.7, marginBottom:16 }}>
          Can't find what you're looking for? We're here for you.
        </p>
        {!showSupport&&!supportSent&&(
          <button onClick={()=>setShowSupport(true)} style={{padding:"10px 24px",background:"#2C1E0E",color:"#FFFCF4",borderRadius:20,fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500,border:"none",cursor:"pointer"}}>
            Contact Support
          </button>
        )}
        {showSupport&&!supportSent&&(
          <div style={{marginTop:16,textAlign:"left"}}>
            <textarea value={supportMsg} onChange={e=>setSupportMsg(e.target.value)} placeholder="Describe your issue or question..." style={{width:"100%",padding:"10px 14px",borderRadius:8,border:"1px solid #E8DBBF",background:"#F5EDD8",color:"#2C1E0E",fontSize:13,fontFamily:"'Lora',Georgia,serif",resize:"none",minHeight:80,outline:"none",lineHeight:1.6,boxSizing:"border-box",marginBottom:8}}/>
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              <button onClick={()=>setShowSupport(false)} style={{padding:"9px 16px",background:"transparent",color:"#A89070",border:"1px solid #E8DBBF",borderRadius:20,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Cancel</button>
              <button onClick={async()=>{
                if(!supportMsg.trim()){alert("Please write your message first.");return;}
                await sendNotificationEmail({
                  to:"support@mytestimonyapp.com",
                  subject:"Support Request from My Testimony App",
                  html:`<div style="font-family:Georgia,serif;padding:24px;"><h2 style="color:#2C1E0E;">Support Request</h2><p style="color:#5A3E28;">${supportMsg}</p></div>`
                });
                setSupportSent(true);
                setShowSupport(false);
              }} style={{padding:"9px 20px",background:"#2C1E0E",color:"#FFFCF4",border:"none",borderRadius:20,cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>Send Message</button>
            </div>
          </div>
        )}
        {supportSent&&(
          <div style={{marginTop:12,padding:"12px 16px",background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8}}>
            <p style={{fontSize:13,color:"#166534",fontFamily:"Inter,sans-serif",margin:0}}>✅ Message sent! We'll get back to you soon.</p>
          </div>
        )}
      </div>

      {/* Scripture */}
      <div style={{ marginTop:32, textAlign:"center" }}>
        <p style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:15, fontStyle:"italic", color:D.TXT3, lineHeight:1.7 }}>
          "Your word is a lamp to my feet and a light to my path."
        </p>
        <p style={{ fontSize:11, color:D.TXT3, marginTop:6, fontFamily:"Inter,sans-serif", opacity:.7 }}>Psalm 119:105</p>
      </div>
    </div>
  );
}


export default function App(){
  const [view,setView]=useState("home"),[dark,setDark]=useState(false);
  const [selected,setSelected]=useState(null),[activeCat,setActiveCat]=useState("All");
  const [query,setQuery]=useState(""),[searchOpen,setSearchOpen]=useState(false);
  const [posts,setPosts]=useState([]),[lang,setLang]=useState("en");
  const [postsLoading,setPostsLoading]=useState(true);
  const [user,setUser]=useState(null); // null = not logged in
  const [showProfile,setShowProfile]=useState(false);
  const [showHelp,setShowHelp]=useState(false); 
  const [showOnboarding,setShowOnboarding]=useState(false);
  const [showResetPassword,setShowResetPassword]=useState(false);
  const [selectedDraft,setSelectedDraft]=useState(null);
  const [newPassword,setNewPassword]=useState("");
  const [resetError,setResetError]=useState("");
  const [resetSuccess,setResetSuccess]=useState(false);
  const [showGroups,setShowGroups]=useState(false); 
  const [fontSize,setFontSize]=useState("medium");
  const [viewingUser,setViewingUser]=useState(null);
  const [streak,setStreak]=useState({current:0,longest:0});

  async function updateStreak(){
    if(!user?.id) return;
    const today = new Date().toLocaleDateString("en-CA");
    const {data} = await supabase.from("streaks").select("*").eq("user_id",user.id).single();
    if(!data){
      await supabase.from("streaks").insert({user_id:user.id,current:1,longest:1,last_read:today});
      setStreak({current:1,longest:1});
    } else {
      const lastDate = data.last_read.split("T")[0];
      if(lastDate===today){
        setStreak({current:data.current,longest:data.longest});
        return;
      }
      const last = new Date(lastDate+"T12:00:00");
      const now  = new Date(today+"T12:00:00");
      const diff = Math.round((now-last)/(1000*60*60*24));
      let newCurrent = data.current;
      if(diff===1){ newCurrent = data.current+1; }
      else if(diff>1){ newCurrent = 1; }
      const newLongest = Math.max(newCurrent, data.longest);
      await supabase.from("streaks").update({current:newCurrent,longest:newLongest,last_read:today}).eq("user_id",user.id);
      setStreak({current:newCurrent,longest:newLongest});
    }
  }

  useEffect(()=>{
    if(user?.id) updateStreak();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.id]);

  // Load posts from Supabase database
 async function loadPostsFromDB() {
    setPostsLoading(true);
    if (SUPABASE_URL === "YOUR_PROJECT_URL_HERE") return; // skip if not connected
    const response = await fetch("https://jgaxzpsnbgnmzfrybhdy.supabase.co/functions/v1/get-posts", {
      headers: {
        "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpnYXh6cHNuYmdubXpmcnliaGR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MjExOTYsImV4cCI6MjA5NDA5NzE5Nn0.1TOF4-levdAG6M2-zN-vDk4t0QbiLYnWqvKHMPNR1IY`
      }
    });
    const data = await response.json();
    const error = data.error;
    if (error) { console.error("Load error:", error.message); return; }
    if (data && data.length > 0) {
      setPosts(data.map(p=>({
        id:       p.id,
        user_id:  p.is_anonymous?null:p.user_id,
        is_anonymous: p.is_anonymous||false,
        title:    p.title,
        content:  p.content,
        excerpt:  p.excerpt,
        category: p.category,
        tags:     p.tags||[],
        coverImg:  p.cover_img,
        bodyImgs: (() => { try { return p.body_imgs ? JSON.parse(p.body_imgs) : []; } catch(e) { return []; } })(),
        likes:    p.likes,
        comments: p.comments,
        featured: p.featured,
        readTime: p.read_time,
        date:     new Date(p.created_at).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"}),
        author:{
          name:       p.is_anonymous?"Anonymous":p.profiles?.name||"Anonymous",
          initials:   p.is_anonymous?"A":p.profiles?.initials||"A",
          color:      p.is_anonymous?"#94a3b8":p.profiles?.color||"#b45309",
          avatar_url: p.is_anonymous?null:p.profiles?.avatar_url||null
        },
        })));
    }
    setPostsLoading(false);
  }

  // Check if user is already logged in when page loads
  useEffect(()=>{
    if (SUPABASE_URL === "YOUR_PROJECT_URL_HERE") return; // skip if not connected
    supabase.auth.getSession().then(async ({ data: { session } })=>{
      if (session) {
        const { data: profile } = await supabase.from("profiles").select("*").eq("id", session.user.id).single();
        if (profile) setUser({ ...session.user, ...profile });
      }
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (_event, session)=>{
      if(_event==="PASSWORD_RECOVERY"){
        setShowResetPassword(true);
      }
      if (!session) setUser(null);
    });
    return ()=>subscription.unsubscribe();
  },[]);

  // Load posts from database on startup
  useEffect(()=>{ 
  loadPostsFromDB(); 
},[]);
  const t=TR[lang]||TR.en;
  const isRtl=lang==="ar";
  const D=dark
    ?{BG:"#1A1410",CARD:"#231D17",NAV:"#1E1810",BDR:"#3A2E22",BDR2:"#4A3C2C",TXT:"#F0E8D8",TXT2:"#C8B898",TXT3:"#8A7060",PUB:"#F0E8D8",PUBBG:"#3A2A18"}
    :{BG,CARD,NAV:CARD,BDR:BORDER,BDR2:BORDER2,TXT:"#2C1E0E",TXT2:"#5A3E28",TXT3:"#A89070",PUB:"#FFFCF4",PUBBG:"#2C1E0E"};

  const [searchType, setSearchType] = useState("all");

  const filtered=useMemo(()=>posts.filter(p=>{
    const mc=activeCat==="All"||p.category===activeCat;
    const q=query.toLowerCase().trim();
    if(!q) return mc;
    switch(searchType){
      case "author":
        return mc&&(p.author?.name?.toLowerCase().includes(q));
      case "scripture":
        return mc&&(p.content?.toLowerCase().includes(q)||p.title?.toLowerCase().includes(q)||p.tags?.some(tg=>tg.toLowerCase().includes(q)));
      case "keyword":
        return mc&&(p.title?.toLowerCase().includes(q)||p.content?.toLowerCase().includes(q)||p.excerpt?.toLowerCase().includes(q));
      default:
        return mc&&(
          p.title?.toLowerCase().includes(q)||
          p.excerpt?.toLowerCase().includes(q)||
          p.content?.toLowerCase().includes(q)||
          p.author?.name?.toLowerCase().includes(q)||
          p.tags?.some(tg=>tg.toLowerCase().includes(q))
        );
    }
  }),[posts,activeCat,query,searchType]);

  const featured=posts.filter(p=>p.featured);
  const rest=filtered.filter(p=>!p.featured||activeCat!=="All"||query);
  const [followingIds,setFollowingIds]=useState([]);

  useEffect(()=>{
    if(!user?.id) return;
    supabase.from("follows").select("following_id").eq("follower_id",user.id)
      .then(({data})=>{ if(data) setFollowingIds(data.map(f=>f.following_id)); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.id]);

  const followingPosts = posts.filter(p=>followingIds.includes(p.user_id));
const doPublish=async data=>{
    const wc=data.content.split(/\s+/).length;
    const cleanTitle   = sanitize(data.title);
    const cleanContent = sanitize(data.content);
    if (containsBadWords(cleanTitle+cleanContent)) {
      alert("Your story contains some words that aren't allowed in our community. Please review and revise before publishing. If you think this is a mistake please contact us.");
      return;
    }
    try {
      
      const { data: savedPost, error } = await supabase.from("posts").insert({
        user_id:   user.id,
        title:     cleanTitle,
        content:   cleanContent,
        excerpt:   cleanContent.replace(/\[img:\d+\]/g,"").trim().slice(0,160)+"...",
        category:  data.cat,
        tags:      [data.cat.toLowerCase()],
        cover_img:    data.coverImg||"",
        body_imgs:    JSON.stringify(data.bodyImgs||[]),
        is_anonymous: data.anonymous===true,
        read_time:    Math.max(1,Math.ceil(wc/200)),
        likes:        0,
        comments:     0,
        featured:     false
      });
     
      if (error) {
        
        alert("Couldn't save your story. Please check your connection and try again.");
        return;
      }
      await loadPostsFromDB();
    } catch(e) {
      alert("Something went wrong. Please check your connection and try again. Your story has not been lost.");
      return;
    }
    setView("home");
  };
if(showResetPassword) return(
    <div style={{minHeight:"100vh",background:D.BG,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <style>{FONTS}</style>
      <div style={{background:D.CARD,borderRadius:16,border:`1px solid ${D.BDR}`,padding:"32px",maxWidth:420,width:"100%",boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:36,marginBottom:8}}>🔑</div>
          <h2 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:22,color:D.TXT,marginBottom:8}}>Set New Password</h2>
          <p style={{fontSize:14,color:D.TXT3,fontFamily:"'Lora',Georgia,serif"}}>Enter your new password below.</p>
        </div>
        {resetError&&<div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:13,color:"#dc2626",fontFamily:"Inter,sans-serif"}}>{resetError}</div>}
        {resetSuccess?(
          <div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8,padding:"16px",textAlign:"center"}}>
            <div style={{fontSize:24,marginBottom:8}}>✅</div>
            <p style={{fontSize:14,color:"#166534",fontFamily:"Inter,sans-serif",fontWeight:600}}>Password updated successfully!</p>
            <button onClick={()=>setShowResetPassword(false)} style={{marginTop:12,padding:"10px 24px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif"}}>Go to Login</button>
          </div>
        ):(
          <>
            <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder="New password (min 8 characters)" style={{width:"100%",padding:"12px 16px",borderRadius:10,border:`1.5px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:14,fontFamily:"Inter,sans-serif",outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
            <button onClick={async()=>{
              if(newPassword.length<8){setResetError("Password must be at least 8 characters.");return;}
              const {error} = await supabase.auth.updateUser({password:newPassword});
              if(error){setResetError(error.message);}
              else{setResetSuccess(true);}
            }} style={{width:"100%",padding:"13px",borderRadius:10,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:15,fontFamily:"'Playfair Display',Georgia,serif",fontWeight:600}}>
              Update Password
            </button>
          </>
        )}
      </div>
    </div>
  );
  if (!user) return showOnboarding
    ? <OnboardingPage onDone={()=>setShowOnboarding(false)} D={D}/>
    : <AuthPage onAuth={u=>setUser(u)} D={D} onShowOnboarding={()=>setShowOnboarding(true)}/>;
  if (user && user.showGuidelines) return <GuidelinesBanner onAccept={()=>setUser(u=>({...u,showGuidelines:false}))}/>;

  if (showGroups) return (
    <div dir={isRtl?"rtl":"ltr"} style={{minHeight:"100vh",background:D.BG}}>
      <style>{FONTS}</style>
      <header style={{background:D.NAV,borderBottom:`1px solid ${D.BDR}`,position:"sticky",top:0,zIndex:100}}>
        <div style={{maxWidth:1100,margin:"0 auto",padding:"0 12px",display:"flex",alignItems:"center",height:64,gap:6,overflowX:"hidden"}}>
          <div onClick={()=>setShowGroups(false)} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flexShrink:0}}>
            <Logo size={36}/>
            <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:17,fontWeight:700,color:D.TXT}}>My Testimony</div>
          </div>
          <div style={{flex:1}}/>
          <button onClick={()=>setShowGroups(false)} style={{padding:"8px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Back to App</button>
        </div>
      </header>
      <main style={{maxWidth:1100,margin:"0 auto",padding:"0 12px"}}>
        <GroupsPage user={user} D={D} posts={posts} setSelected={setSelected} setView={setView} setShowGroups={setShowGroups}/>
      </main>
    </div>
  );if (showHelp) return (
    <div dir={isRtl?"rtl":"ltr"} style={{minHeight:"100vh",background:D.BG}}>
      <style>{FONTS}</style>
      <header style={{background:D.NAV,borderBottom:`1px solid ${D.BDR}`,position:"sticky",top:0,zIndex:100}}>
        <div style={{maxWidth:1100,margin:"0 auto",padding:"0 8px",display:"flex",alignItems:"center",height:64,gap:4,overflowX:"hidden",overflowY:"visible"}}>
          <div onClick={()=>{setShowHelp(false);}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flexShrink:0}}>
            <Logo size={36}/>
            <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:17,fontWeight:700,color:D.TXT}}>My Testimony</div>
          </div>
          <div style={{flex:1}}/>
          <button onClick={()=>setShowHelp(false)} style={{padding:"8px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Back to App</button>
        </div>
      </header>
      <main style={{maxWidth:1100,margin:"0 auto",padding:"0 12px"}}>
        <HelpPage onBack={()=>setShowHelp(false)} D={D}/>
      </main>
    </div>
  );

  if (showProfile) return (
    <div dir={isRtl?"rtl":"ltr"} style={{minHeight:"100vh",background:D.BG,overflowX:"hidden",width:"100%"}}>
      <style>{FONTS}</style>
      <header style={{background:D.NAV,borderBottom:`1px solid ${D.BDR}`,position:"sticky",top:0,zIndex:100}}>
        <div style={{maxWidth:1100,margin:"0 auto",padding:"0 8px",display:"flex",alignItems:"center",height:64,gap:4,overflowX:"hidden",overflowY:"visible"}}>
          <div onClick={()=>setShowProfile(false)} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flexShrink:0}}>
            <Logo size={36}/>
            <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:17,fontWeight:700,color:D.TXT}}>My Testimony</div>
          </div>
          <div style={{flex:1}}/>
          <button onClick={async()=>{await supabase.auth.signOut();setUser(null);setShowProfile(false);}} style={{padding:"8px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:"transparent",color:D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif"}}>Sign Out</button>
        </div>
      </header>
      <ProfilePage user={user} setUser={setUser} posts={posts} streak={streak} onBack={()=>setShowProfile(false)} D={D} setSelected={setSelected} setView={setView} setShowProfile={setShowProfile} loadPostsFromDB={loadPostsFromDB} setSelectedDraft={setSelectedDraft}/>
    </div>
  );

  return(
    <>
      <style>{FONTS}{MOBILE_CSS}</style>
      {viewingUser&&<UserProfileModal profileUser={viewingUser} currentUser={user} D={D} onClose={()=>setViewingUser(null)} posts={posts}/>}
      <div dir={isRtl?"rtl":"ltr"} style={{minHeight:"100vh",background:D.BG,transition:"background .25s",overflowX:"hidden",width:"100%"}}>
        {view!=="write"&&(
          <header style={{background:D.NAV,borderBottom:`1px solid ${D.BDR}`,position:"sticky",top:0,zIndex:100,boxShadow:"0 1px 8px rgba(100,70,20,.07)",overflowX:"auto"}}>
            <div style={{maxWidth:1100,margin:"0 auto",padding:"0 20px",display:"flex",alignItems:"center",height:64,gap:10}}>
              <div onClick={()=>{setView("home");setSelected(null);setQuery("");setActiveCat("All");}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",flexShrink:0}}>
                <Logo size={36}/>
                <div>
                  <div style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:17,fontWeight:700,color:D.TXT,lineHeight:1,letterSpacing:"-.01em"}}>My Testimony</div>
                  <div style={{fontSize:8,color:D.TXT3,letterSpacing:".07em",fontFamily:"Inter,sans-serif",textTransform:"uppercase",marginTop:1}}>{t.hero}</div>
                </div>
              </div>
              <div style={{flex:1}}/>
              {searchOpen
                ?<div style={{display:"flex",alignItems:"center",gap:6}}>
                  <input autoFocus value={query} onChange={e=>setQuery(e.target.value)} onBlur={()=>{if(!query)setSearchOpen(false);}} placeholder={searchType==="author"?"Search by author...":searchType==="scripture"?"Search by scripture...":"Search testimonies..."} style={{width:200,padding:"8px 14px",borderRadius:20,border:`1.5px solid ${D.BDR2}`,background:D.BG,color:D.TXT,fontSize:13,fontFamily:"Inter,sans-serif",outline:"none"}}/>
                  <select value={searchType} onChange={e=>setSearchType(e.target.value)} style={{padding:"7px 10px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.BG,color:D.TXT,fontSize:12,fontFamily:"Inter,sans-serif",outline:"none",cursor:"pointer"}}>
                    <option value="all">All</option>
                    <option value="author">Author</option>
                    <option value="scripture">Scripture</option>
                    <option value="keyword">Keyword</option>
                  </select>
                </div>
                :<button onClick={()=>setSearchOpen(true)} style={{background:"none",border:"none",cursor:"pointer",color:D.TXT3,padding:6}}><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg></button>
              }
              <LangMenu lang={lang} setLang={setLang} D={D}/><button onClick={()=>setShowGroups(true)} className="nav-btn" style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:20,cursor:"pointer",color:D.TXT3,padding:"6px 11px",display:"flex",alignItems:"center",gap:5,fontSize:12,fontFamily:"Inter,sans-serif"}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                <span className="nav-label">Groups</span>
              </button>
              <button onClick={()=>setDark(v=>!v)} style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:20,cursor:"pointer",color:D.TXT3,padding:"6px 10px",display:"flex",alignItems:"center",gap:5,fontSize:12,fontFamily:"Inter,sans-serif"}}>
                {dark?<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>:<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>}
                <span style={{display:"none"}}>{dark?t.light:t.night}</span>
              </button>
              <button onClick={()=>setView("write")} style={{display:"flex",alignItems:"center",gap:6,padding:"9px 14px",borderRadius:20,background:D.PUBBG,color:D.PUB,border:"none",cursor:"pointer",fontSize:13,fontFamily:"Inter,sans-serif",fontWeight:500}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                {t.share}
              </button>
              {/* Help */}
              <button onClick={()=>setShowHelp(true)} title="Help Center" style={{background:"none",border:`1px solid ${D.BDR}`,borderRadius:20,cursor:"pointer",color:D.TXT3,padding:"6px 11px",display:"flex",alignItems:"center",gap:5,fontSize:12,fontFamily:"Inter,sans-serif"}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                Help
              </button>
              {/* User avatar */}
              <button onClick={()=>setShowProfile(true)} title="Your profile" style={{width:34,height:34,borderRadius:"50%",background:user.color+"22",border:`2px solid ${user.color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:user.color,fontFamily:"'Playfair Display',serif",cursor:"pointer",flexShrink:0,overflow:"hidden",padding:0}}>
                {user.avatar_url
                  ? <img src={user.avatar_url} alt={user.name} style={{width:34,height:34,objectFit:"cover",borderRadius:"50%"}}/>
                  : user.initials
                }
              </button>
            </div>
          </header>
        )}
        <main style={{maxWidth:1100,margin:"0 auto",padding:"0 24px"}}>
          {view==="write"&&<WritePost onPublish={doPublish} onBack={()=>{setView("home");setSelectedDraft(null);}} D={D} t={t} user={user} draft={selectedDraft}/>}
         
        {view==="post"&&selected&&<PostDetail key={selected.id} post={selected} onBack={()=>{setView("home");setSelected(null);}} D={D} t={t} user={user} setViewingUser={setViewingUser} fontSize={fontSize} setFontSize={setFontSize} dark={dark}/>}
          {view==="home"&&(
            <>
            {query&&(
              <div style={{padding:"12px 0",marginBottom:8}}>
                <span style={{fontSize:13,color:D.TXT3,fontFamily:"Inter,sans-serif"}}>
                  {filtered.length} result{filtered.length!==1?"s":""} for <strong style={{color:D.TXT}}>"{query}"</strong>
                  {searchType!=="all"&&<span> in <strong style={{color:"#b45309"}}>{searchType}</strong></span>}
                </span>
              </div>
            )}
              {!query&&activeCat==="All"&&(()=>{
              const today = new Date();
              const seed = today.getFullYear()*10000 + (today.getMonth()+1)*100 + today.getDate();
              const daily = posts[seed % posts.length];
              if(!daily) return null;
              return(
                <div style={{background:dark?"linear-gradient(135deg,#2A2018,#231D17)":"linear-gradient(135deg,#FEF3C7,#FFFCF4)",border:`2px solid ${dark?"#4A3C2C":"#FCD34D"}`,borderRadius:16,padding:"20px 24px",marginBottom:24,cursor:"pointer"}} onClick={()=>{setSelected(daily);setView("post");}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                    <span style={{fontSize:18}}>✨</span>
                    <span style={{fontSize:11,fontWeight:700,color:dark?"#C8A96E":"#92400E",fontFamily:"Inter,sans-serif",letterSpacing:".08em",textTransform:"uppercase"}}>Daily Testimony — {new Date().toLocaleDateString("en-US",{month:"long",day:"numeric"})}</span>
                  </div>
                  <h3 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:8,lineHeight:1.3}}>{daily.title}</h3>
                  <p style={{fontSize:14,color:D.TXT2,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7,marginBottom:12}}>{daily.excerpt}</p>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <Avi a={daily.author} size={26}/>
                    <span style={{fontSize:12,color:dark?"#C8A96E":"#92400E",fontFamily:"Inter,sans-serif",fontWeight:500}}>{daily.author.name}</span>
                    <span style={{fontSize:11,color:dark?"#C8A96E":"#b45309",fontFamily:"Inter,sans-serif",marginLeft:"auto"}}>Read today's testimony →</span>
                  </div>
                </div>
              );
            })()}

            {!query&&activeCat==="All"&&(
                <div style={{padding:"44px 0 28px",textAlign:"center"}}>
                  <div style={{display:"flex",justifyContent:"center",marginBottom:14}}><Logo size={68}/></div>
                  <h1 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:38,fontWeight:700,color:D.TXT,lineHeight:1.15,marginBottom:12,letterSpacing:"-.01em"}}>{t.hero}</h1>
                  <p style={{fontSize:17,color:D.TXT2,maxWidth:480,margin:"0 auto 26px",lineHeight:1.75,fontFamily:"'Lora',Georgia,serif"}}>{t.tagline}</p>
                  <div style={{display:"flex",justifyContent:"center",gap:10,flexWrap:"wrap"}}>
                    {[`${posts.length}+ Stories`,t.stat2,t.stat3].map(s=><span key={s} style={{fontSize:12,fontFamily:"Inter,sans-serif",color:D.TXT3,padding:"6px 16px",borderRadius:20,border:`1px solid ${D.BDR}`,background:D.CARD}}>{s}</span>)}
                  </div>
                </div>
              )}
              <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4,marginBottom:24,scrollbarWidth:"none"}}>
                {CATS.map(cat=>{
                  const cs=CAT_STYLE[cat],active=activeCat===cat;
                  return <button key={cat} onClick={()=>setActiveCat(cat)} style={{padding:"7px 16px",borderRadius:20,whiteSpace:"nowrap",border:`1.5px solid ${active?(cs?cs.border:D.BDR2):D.BDR}`,background:active?(cs?cs.bg:D.CARD):D.CARD,color:active?(cs?cs.text:D.TXT):D.TXT3,cursor:"pointer",fontSize:12,fontFamily:"Inter,sans-serif",fontWeight:active?600:400,flexShrink:0}}>{cat}</button>;
                })}
              </div>
              {!query&&activeCat==="All"&&followingPosts.length>0&&(
              <div style={{marginBottom:24}}>
                <h2 style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:20,fontWeight:700,color:D.TXT,marginBottom:14,display:"flex",alignItems:"center",gap:8}}>
                  <span>👥</span> From People You Follow
                </h2>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(290px,1fr))",gap:14}}>
                  {followingPosts.slice(0,3).map(post=>(
                    <StoryCard key={post.id} post={post} onClick={()=>{setSelected(post);setView("post");}} D={D} user={user}/>
                  ))}
                </div>
              </div>
            )}
              {!query&&activeCat==="All"&&featured.length>=2&&(
                <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:20,marginBottom:20}}>
                  <HeroCard post={featured[0]} onClick={()=>{setSelected(featured[0]);setView("post");}} D={D} t={t}/>
                  <StoryCard post={featured[1]} onClick={()=>{setSelected(featured[1]);setView("post");}} compact={true} D={D} user={user}/>
                </div>
              )}
              {query&&<p style={{fontSize:13,color:D.TXT3,fontFamily:"Inter,sans-serif",marginBottom:18}}>{filtered.length} {filtered.length!==1?t.results:t.result} for "{query}"</p>}
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(290px,1fr))",gap:18}}>
                {(query||activeCat!=="All"?filtered:rest).map(post=><StoryCard key={post.id} post={post} onClick={()=>{setSelected(post);setView("post");}} D={D} user={user}/>)}
              </div>
              {filtered.length===0&&!postsLoading&&(
                <div style={{textAlign:"center",padding:"60px 20px",color:D.TXT3}}>
                  <div style={{fontSize:48,marginBottom:16}}>🕊️</div>
                  <p style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:22,marginBottom:8,color:D.TXT,fontWeight:700}}>{query?t.noStories:"No testimonies yet"}</p>
                  <p style={{fontSize:14,fontFamily:"'Lora',Georgia,serif",lineHeight:1.7,maxWidth:340,margin:"0 auto 24px"}}>{query?t.trySearch:"Be the first to share what God has done in your life."}</p>
                  {!query&&<button onClick={()=>setView("write")} style={{padding:"12px 24px",borderRadius:20,background:"#2C1E0E",color:"#FFFCF4",border:"none",cursor:"pointer",fontSize:14,fontFamily:"Inter,sans-serif",fontWeight:500}}>Share Your Story</button>}
                </div>
              )}
              <div style={{borderTop:`1px solid ${D.BDR}`,marginTop:52,padding:"32px 0 16px",textAlign:"center"}}>
                <p style={{fontFamily:"'Playfair Display',Georgia,serif",fontSize:16,fontStyle:"italic",color:D.TXT3,lineHeight:1.7}}>"{t.rev}"</p>
                <p style={{fontSize:12,color:D.TXT3,marginTop:8,fontFamily:"Inter,sans-serif",opacity:.7}}>{t.revRef}</p>
              </div>
            </>
          )}
        </main>
      </div>
    </>
  );
}
